import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type AvailableMonth = {
  __typename?: 'AvailableMonth';
  yyyymm: Scalars['String'];
};

export enum ClusterState {
  Complete = 'COMPLETE',
  Error = 'ERROR',
  NoRecord = 'NO_RECORD',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type ContractExservice = {
  __typename?: 'ContractExservice';
  exservice: Scalars['String'];
};

export enum DateGroup {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export enum Device {
  Pc = 'PC',
  Sp = 'SP'
}

export type Extract = {
  __typename?: 'Extract';
  ageBrackets: Array<ExtractAgeBracket>;
  appUsage: ExtractAppUsage;
  apps: Array<ExtractApp>;
  aroundMin: Scalars['Int'];
  avgAge?: Maybe<Scalars['Float']>;
  avgGender?: Maybe<Scalars['Float']>;
  beforeAfter: Array<Scalars['JSON']>;
  beforeAfterApp: Array<Scalars['JSON']>;
  beforeAfterSankey: Array<Scalars['JSON']>;
  beforeAfterWord: Array<Scalars['JSON']>;
  bodyTrouble: ExtractBodyTrouble;
  childData: Array<ExtractChild>;
  cluster: ExtractCluster;
  clusterAppUsage?: Maybe<Scalars['JSON']>;
  clusterAttributes?: Maybe<Scalars['JSON']>;
  clusterDisposableIncome?: Maybe<Scalars['JSON']>;
  clusterFamily?: Maybe<Scalars['JSON']>;
  clusterLivingStyle?: Maybe<Scalars['JSON']>;
  clusterMediaContact?: Maybe<Scalars['JSON']>;
  clusterOwnedAssets?: Maybe<Scalars['JSON']>;
  condition: Scalars['JSON'];
  contractid: Scalars['String'];
  createdAt: Scalars['DateTime'];
  disposableIncome: ExtractDisposableIncome;
  enableBefAft: Scalars['Boolean'];
  endYm: Scalars['String'];
  enqversion: Scalars['Int'];
  extractid: Scalars['Int'];
  familyData: ExtractFamily;
  genderAgeBrackets: Array<ExtractGenderAgeBracket>;
  general: ExtractGeneral;
  hitCount: Array<Scalars['JSON']>;
  homeIncomeData: Array<ExtractHomeIncome>;
  interest: ExtractInterest;
  items: Scalars['JSON'];
  jobs: Array<ExtractJob>;
  jsonVersion: Scalars['String'];
  livingAreaData: Array<ExtractLivingArea>;
  livingStyleData: ExtractLivingStyle;
  marriageData: Array<ExtractMarriage>;
  mediaContact: ExtractMediaContact;
  ownedAssets: ExtractOwnedAssets;
  pages: Array<ExtractPage>;
  searchWords: Array<ExtractSearchWord>;
  shared: Scalars['Boolean'];
  shopping: ExtractShopping;
  siteCategoryData: Array<ExtractSiteCategory>;
  sites: Array<ExtractSite>;
  spending: ExtractSpending;
  sports: ExtractSports;
  startYm: Scalars['String'];
  state: State;
  title: Scalars['String'];
  trend: Array<ExtractTrend>;
  user: ExtractUser;
  userCount: Scalars['Int'];
  userList: ExtractUserList;
  userid: Scalars['String'];
  users: Array<Scalars['Int']>;
  weekdayHour: Array<ExtractWeekdayHour>;
  words: Array<ExtractWord>;
};


export type ExtractAgeBracketsArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
};


export type ExtractAppUsageArgs = {
  app: Scalars['String'];
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
};


export type ExtractAppsArgs = {
  appCategories?: InputMaybe<Array<Scalars['String']>>;
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type ExtractAvgAgeArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
};


export type ExtractAvgGenderArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
};


export type ExtractBeforeAfterArgs = {
  beforeAfter: Scalars['Int'];
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type ExtractBeforeAfterAppArgs = {
  beforeAfter: Scalars['Int'];
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type ExtractBeforeAfterSankeyArgs = {
  beforeAfter: Scalars['Int'];
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  site?: InputMaybe<Scalars['String']>;
  word?: InputMaybe<Scalars['String']>;
};


export type ExtractBeforeAfterWordArgs = {
  beforeAfter: Scalars['Int'];
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type ExtractBodyTroubleArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
  troubleType: Scalars['String'];
};


export type ExtractChildDataArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
};


export type ExtractDisposableIncomeArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
};


export type ExtractFamilyDataArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
};


export type ExtractGenderAgeBracketsArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
};


export type ExtractHitCountArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
};


export type ExtractHomeIncomeDataArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
};


export type ExtractInterestArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
};


export type ExtractItemsArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type ExtractJobsArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
};


export type ExtractLivingAreaDataArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
};


export type ExtractLivingStyleDataArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
};


export type ExtractMarriageDataArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
};


export type ExtractMediaContactArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
  media: Scalars['String'];
};


export type ExtractOwnedAssetsArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
};


export type ExtractSearchWordsArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
  word: Scalars['String'];
};


export type ExtractShoppingArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
  question: Scalars['String'];
};


export type ExtractSitesArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  siteCategories?: InputMaybe<Array<Scalars['String']>>;
};


export type ExtractSpendingArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
};


export type ExtractSportsArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
  watchOrPlay: Scalars['String'];
};


export type ExtractTrendArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  dateGroup: DateGroup;
  filter?: InputMaybe<ExtractFilter>;
};


export type ExtractUserCountArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  device?: InputMaybe<Device>;
  filter?: InputMaybe<ExtractFilter>;
  liked?: InputMaybe<Scalars['Boolean']>;
};


export type ExtractUserListArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
  liked?: InputMaybe<Scalars['Boolean']>;
};


export type ExtractUsersArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  device?: InputMaybe<Device>;
  filter?: InputMaybe<ExtractFilter>;
  liked?: InputMaybe<Scalars['Boolean']>;
};


export type ExtractWeekdayHourArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
};


export type ExtractWordsArgs = {
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type ExtractAgeBracket = {
  __typename?: 'ExtractAgeBracket';
  ageBracket: Scalars['String'];
  usersRate: Scalars['Float'];
};

export type ExtractApp = {
  __typename?: 'ExtractApp';
  app: Scalars['String'];
  category?: Maybe<Scalars['String']>;
  score: Scalars['Float'];
  title?: Maybe<Scalars['String']>;
  usersRate: Scalars['Float'];
};

export type ExtractAppUsage = {
  __typename?: 'ExtractAppUsage';
  monitor: Array<ExtractAppUsageRow>;
  target: Array<ExtractAppUsageRow>;
  validState: ValidState;
};

export type ExtractAppUsageRow = {
  __typename?: 'ExtractAppUsageRow';
  usersRate: Scalars['Float'];
  value: Scalars['String'];
};

export type ExtractBodyTrouble = {
  __typename?: 'ExtractBodyTrouble';
  data: Array<ExtractBodyTroubleRow>;
  validState: ValidState;
};

export type ExtractBodyTroubleRow = {
  __typename?: 'ExtractBodyTroubleRow';
  bodyTrouble: Scalars['String'];
  score: Scalars['Float'];
  usersRate: Scalars['Float'];
};

export type ExtractChild = {
  __typename?: 'ExtractChild';
  child: Scalars['String'];
  type: Scalars['String'];
  usersRate: Scalars['Float'];
};

export type ExtractCluster = {
  __typename?: 'ExtractCluster';
  clusters: Array<ExtractClusterObject>;
  state: ClusterState;
  stopwords: Array<Scalars['String']>;
};

export type ExtractClusterObject = {
  __typename?: 'ExtractClusterObject';
  clusterid: Scalars['Int'];
  name: Scalars['String'];
  sites: Array<ExtractClusterSite>;
  users: Scalars['Int'];
  words: Array<ExtractClusterWord>;
};

export type ExtractClusterSite = {
  __typename?: 'ExtractClusterSite';
  score: Scalars['Float'];
  site: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type ExtractClusterWord = {
  __typename?: 'ExtractClusterWord';
  score: Scalars['Float'];
  word: Scalars['String'];
};

export type ExtractDisposableIncome = {
  __typename?: 'ExtractDisposableIncome';
  monitor: Array<ExtractDisposableIncomeRow>;
  target: Array<ExtractDisposableIncomeRow>;
  validState: ValidState;
};

export type ExtractDisposableIncomeRow = {
  __typename?: 'ExtractDisposableIncomeRow';
  usersRate: Scalars['Float'];
  value: Scalars['String'];
};

export type ExtractFamily = {
  __typename?: 'ExtractFamily';
  monitor: Array<ExtractFamilyRow>;
  target: Array<ExtractFamilyRow>;
  validState: ValidState;
};

export type ExtractFamilyRow = {
  __typename?: 'ExtractFamilyRow';
  usersRate: Scalars['Float'];
  value: Scalars['String'];
};

export type ExtractFilter = {
  ageBracket?: InputMaybe<Array<Scalars['String']>>;
  app?: InputMaybe<Array<Scalars['String']>>;
  appCategory?: InputMaybe<Array<Scalars['String']>>;
  child?: InputMaybe<Array<Scalars['String']>>;
  dateRange?: InputMaybe<ExtractFilterDateRange>;
  device?: InputMaybe<Array<Scalars['String']>>;
  gender?: InputMaybe<Array<Scalars['String']>>;
  homeIncome?: InputMaybe<Array<Scalars['String']>>;
  job?: InputMaybe<Array<Scalars['String']>>;
  keyword?: InputMaybe<Array<Scalars['String']>>;
  marriage?: InputMaybe<Array<Scalars['String']>>;
  prefecture?: InputMaybe<Array<Scalars['String']>>;
  siteCategory?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Array<Scalars['String']>>;
  url?: InputMaybe<Array<Scalars['String']>>;
};

export type ExtractFilterDateRange = {
  end: Scalars['String'];
  start: Scalars['String'];
};

export type ExtractGenderAgeBracket = {
  __typename?: 'ExtractGenderAgeBracket';
  ageBracket: Scalars['String'];
  gender: Scalars['String'];
  type: Scalars['String'];
  usersRate: Scalars['Float'];
};

export type ExtractGeneral = {
  __typename?: 'ExtractGeneral';
  attributes?: Maybe<Scalars['JSON']>;
  landingPages?: Maybe<Scalars['JSON']>;
  sites?: Maybe<Scalars['JSON']>;
  trend?: Maybe<Scalars['JSON']>;
  words?: Maybe<Scalars['JSON']>;
};


export type ExtractGeneralAttributesArgs = {
  app?: InputMaybe<Scalars['String']>;
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
  site?: InputMaybe<Scalars['String']>;
  word?: InputMaybe<Scalars['String']>;
};


export type ExtractGeneralLandingPagesArgs = {
  befaft?: InputMaybe<Scalars['Int']>;
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
  site?: InputMaybe<Scalars['String']>;
  word?: InputMaybe<Scalars['String']>;
};


export type ExtractGeneralSitesArgs = {
  befaft?: InputMaybe<Scalars['Int']>;
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
  site?: InputMaybe<Scalars['String']>;
  word?: InputMaybe<Scalars['String']>;
};


export type ExtractGeneralTrendArgs = {
  app?: InputMaybe<Scalars['String']>;
  clusterid?: InputMaybe<Scalars['Int']>;
  dateGroup: DateGroup;
  filter?: InputMaybe<ExtractFilter>;
  site?: InputMaybe<Scalars['String']>;
  word?: InputMaybe<Scalars['String']>;
};


export type ExtractGeneralWordsArgs = {
  befaft?: InputMaybe<Scalars['Int']>;
  clusterid?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<ExtractFilter>;
  site?: InputMaybe<Scalars['String']>;
  split: Scalars['Boolean'];
  word?: InputMaybe<Scalars['String']>;
};

export type ExtractHomeIncome = {
  __typename?: 'ExtractHomeIncome';
  homeIncome: Scalars['String'];
  type: Scalars['String'];
  usersRate: Scalars['Float'];
};

export type ExtractInput = {
  aroundMin: Scalars['Int'];
  conditions: Scalars['JSON'];
  endYm: Scalars['String'];
  excludeConditions: Scalars['JSON'];
  extractOperator: Operator;
  startYm: Scalars['String'];
  title: Scalars['String'];
};

export type ExtractInterest = {
  __typename?: 'ExtractInterest';
  interests: Array<ExtractInterestRow>;
  validState: ValidState;
};

export type ExtractInterestRow = {
  __typename?: 'ExtractInterestRow';
  interest: Scalars['String'];
  score: Scalars['Float'];
  usersRate: Scalars['Float'];
};

export type ExtractJob = {
  __typename?: 'ExtractJob';
  job: Scalars['String'];
  type: Scalars['String'];
  usersRate: Scalars['Float'];
};

export type ExtractList = {
  __typename?: 'ExtractList';
  extracts: Array<Extract>;
  total: Scalars['Int'];
};

export type ExtractLivingArea = {
  __typename?: 'ExtractLivingArea';
  livingArea: Scalars['String'];
  type: Scalars['String'];
  usersRate: Scalars['Float'];
};

export type ExtractLivingStyle = {
  __typename?: 'ExtractLivingStyle';
  monitor: Array<ExtractLivingStyleRow>;
  target: Array<ExtractLivingStyleRow>;
  validState: ValidState;
};

export type ExtractLivingStyleRow = {
  __typename?: 'ExtractLivingStyleRow';
  usersRate: Scalars['Float'];
  value: Scalars['String'];
};

export type ExtractMarriage = {
  __typename?: 'ExtractMarriage';
  marriage: Scalars['String'];
  type: Scalars['String'];
  usersRate: Scalars['Float'];
};

export type ExtractMediaContact = {
  __typename?: 'ExtractMediaContact';
  monitor: Array<ExtractMediaContactRow>;
  target: Array<ExtractMediaContactRow>;
  validState: ValidState;
};

export type ExtractMediaContactRow = {
  __typename?: 'ExtractMediaContactRow';
  usersRate: Scalars['Float'];
  value: Scalars['String'];
};

export type ExtractOwnedAssets = {
  __typename?: 'ExtractOwnedAssets';
  monitor: Array<ExtractOwnedAssetsRow>;
  target: Array<ExtractOwnedAssetsRow>;
  validState: ValidState;
};

export type ExtractOwnedAssetsRow = {
  __typename?: 'ExtractOwnedAssetsRow';
  usersRate: Scalars['Float'];
  value: Scalars['String'];
};

export type ExtractPage = {
  __typename?: 'ExtractPage';
  page: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  usersRate: Scalars['Float'];
};

export type ExtractSearchWord = {
  __typename?: 'ExtractSearchWord';
  searchWord: Scalars['String'];
  users: Scalars['Float'];
};

export type ExtractShopping = {
  __typename?: 'ExtractShopping';
  monitor: Array<ExtractShoppingRow>;
  target: Array<ExtractShoppingRow>;
  validState: ValidState;
};

export type ExtractShoppingRow = {
  __typename?: 'ExtractShoppingRow';
  usersRate: Scalars['Float'];
  value: Scalars['String'];
};

export type ExtractSite = {
  __typename?: 'ExtractSite';
  score: Scalars['Float'];
  site: Scalars['String'];
  siteCategory?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  usersRate: Scalars['Float'];
};

export type ExtractSiteCategory = {
  __typename?: 'ExtractSiteCategory';
  siteCategory: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  usersRate: Scalars['Float'];
};

export type ExtractSpending = {
  __typename?: 'ExtractSpending';
  monitor: Array<ExtractSpendingRow>;
  target: Array<ExtractSpendingRow>;
  validState: ValidState;
};

export type ExtractSpendingRow = {
  __typename?: 'ExtractSpendingRow';
  amount: Scalars['Float'];
  spending: Scalars['String'];
};

export type ExtractSports = {
  __typename?: 'ExtractSports';
  data: Array<ExtractSportsRow>;
  validState: ValidState;
};

export type ExtractSportsRow = {
  __typename?: 'ExtractSportsRow';
  score: Scalars['Float'];
  sports: Scalars['String'];
  usersRate: Scalars['Float'];
};

export type ExtractTrend = {
  __typename?: 'ExtractTrend';
  date: Scalars['String'];
  sessions: Scalars['Float'];
  sessionsRate: Scalars['Float'];
  type: Scalars['String'];
};

export type ExtractUser = {
  __typename?: 'ExtractUser';
  username: Scalars['String'];
};

export type ExtractUserList = {
  __typename?: 'ExtractUserList';
  appCategories: Scalars['JSON'];
  note: Scalars['String'];
  sessions: Array<ExtractUserSessionRow>;
  siteCategories: Scalars['JSON'];
  total: Scalars['Int'];
  totalSessions: Scalars['Int'];
  userWords: Array<ExtractUserWordRow>;
  users: Array<ExtractUserRow>;
};


export type ExtractUserListAppCategoriesArgs = {
  extractuserid: Scalars['Int'];
};


export type ExtractUserListNoteArgs = {
  extractuserid: Scalars['Int'];
};


export type ExtractUserListSessionsArgs = {
  appCategory?: InputMaybe<Array<Scalars['String']>>;
  extractuserid: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  siteCategory?: InputMaybe<Array<Scalars['String']>>;
  withApp?: InputMaybe<Scalars['Boolean']>;
  withItem?: InputMaybe<Scalars['Boolean']>;
};


export type ExtractUserListSiteCategoriesArgs = {
  extractuserid: Scalars['Int'];
};


export type ExtractUserListTotalSessionsArgs = {
  extractuserid: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type ExtractUserListUserWordsArgs = {
  extractuserid: Scalars['Int'];
  siteCategory?: InputMaybe<Array<Scalars['String']>>;
};


export type ExtractUserListUsersArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type ExtractUserRow = {
  __typename?: 'ExtractUserRow';
  ageBracket: Scalars['String'];
  blocks?: Maybe<Scalars['Int']>;
  child: Scalars['String'];
  clusterid?: Maybe<Scalars['Int']>;
  dbname: Scalars['String'];
  extractuserid: Scalars['Int'];
  gender: Scalars['String'];
  homeIncome?: Maybe<Scalars['String']>;
  job?: Maybe<Scalars['String']>;
  liked: Scalars['Int'];
  likes: Scalars['Int'];
  marriage: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  prefecture: Scalars['String'];
  vid: Scalars['String'];
};

export type ExtractUserSessionRow = {
  __typename?: 'ExtractUserSessionRow';
  accessTime: Scalars['DateTime'];
  base: Scalars['Boolean'];
  blockid: Scalars['Int'];
  comment?: Maybe<Scalars['String']>;
  extractsessionid: Scalars['Int'];
  extractuserid: Scalars['Int'];
  filter?: Maybe<Scalars['Int']>;
  pv: Scalars['Int'];
  refCatName: Scalars['String'];
  refKeyword: Scalars['String'];
  refUrl: Scalars['String'];
  row: Scalars['Int'];
  site?: Maybe<Scalars['String']>;
  timeOn: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  url: Scalars['String'];
};

export type ExtractUserWordRow = {
  __typename?: 'ExtractUserWordRow';
  cnt: Scalars['Int'];
  word: Scalars['String'];
};

export type ExtractWeekdayHour = {
  __typename?: 'ExtractWeekdayHour';
  hour: Scalars['Int'];
  sessionsRate: Scalars['Float'];
  weekday: Scalars['Int'];
};

export type ExtractWord = {
  __typename?: 'ExtractWord';
  age: Scalars['Float'];
  femaleRate: Scalars['Float'];
  score: Scalars['Float'];
  usersRate: Scalars['Float'];
  word: Scalars['String'];
};

export type Item = {
  __typename?: 'Item';
  asin: Scalars['String'];
  brand?: Maybe<Scalars['String']>;
  cat1?: Maybe<Scalars['String']>;
  cat2?: Maybe<Scalars['String']>;
  cat3?: Maybe<Scalars['String']>;
  cnt: Scalars['Int'];
  itemname?: Maybe<Scalars['String']>;
  listPrice?: Maybe<Scalars['Int']>;
};

export type Menu = {
  __typename?: 'Menu';
  canDownload: Scalars['Boolean'];
  canStory: Scalars['Boolean'];
  contractType: Scalars['String'];
  count: Scalars['Int'];
  isTrial: Scalars['Boolean'];
  maxCount: Scalars['Int'];
  maxExtractSaves: Scalars['Int'];
  menuid: Scalars['String'];
  termEnd: Scalars['String'];
  termStart: Scalars['String'];
  validRange: Array<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  approveExtract: Scalars['Boolean'];
  canExtract: Scalars['Boolean'];
  createExtract?: Maybe<Scalars['Int']>;
  deleteExtract: Scalars['Boolean'];
  executeCluster: Scalars['Boolean'];
  shareExtract: Scalars['Boolean'];
  updateClusterName: Scalars['Boolean'];
  updateComment: Scalars['Boolean'];
  updateExtract: Scalars['Boolean'];
  updateLiked: Scalars['Boolean'];
  updateNote: Scalars['Boolean'];
  updateStopwords: Scalars['Boolean'];
};


export type MutationApproveExtractArgs = {
  extractid: Scalars['Int'];
};


export type MutationCreateExtractArgs = {
  data: ExtractInput;
};


export type MutationDeleteExtractArgs = {
  extractid: Scalars['Int'];
};


export type MutationExecuteClusterArgs = {
  clusterNum: Scalars['Int'];
  extractid: Scalars['Int'];
  userids?: InputMaybe<Array<Scalars['Int']>>;
};


export type MutationShareExtractArgs = {
  extractid: Scalars['Int'];
  share: Scalars['Boolean'];
};


export type MutationUpdateClusterNameArgs = {
  clusterid: Scalars['Int'];
  extractid: Scalars['Int'];
  name: Scalars['String'];
};


export type MutationUpdateCommentArgs = {
  comment?: InputMaybe<Scalars['String']>;
  extractid: Scalars['Int'];
  extractsessionid: Scalars['Int'];
  extractuserid: Scalars['Int'];
};


export type MutationUpdateExtractArgs = {
  extractid: Scalars['Int'];
  title: Scalars['String'];
};


export type MutationUpdateLikedArgs = {
  extractid: Scalars['Int'];
  extractuserid: Scalars['Int'];
  liked: Scalars['Boolean'];
};


export type MutationUpdateNoteArgs = {
  extractid: Scalars['Int'];
  extractuserid: Scalars['Int'];
  note: Scalars['String'];
};


export type MutationUpdateStopwordsArgs = {
  extractid: Scalars['Int'];
  stopwords: Array<Scalars['String']>;
};

export enum Operator {
  And = 'AND',
  Or = 'OR'
}

export type Query = {
  __typename?: 'Query';
  availableMonth: AvailableMonth;
  brands: Array<Scalars['JSON']>;
  categories: Array<Scalars['JSON']>;
  extract?: Maybe<Extract>;
  extractList?: Maybe<ExtractList>;
  item?: Maybe<Item>;
  itemNames: Array<Scalars['JSON']>;
  items: Array<Item>;
  testCondition: Array<Scalars['JSON']>;
  user?: Maybe<User>;
};


export type QueryBrandsArgs = {
  pattern?: InputMaybe<Scalars['String']>;
};


export type QueryCategoriesArgs = {
  matchType?: InputMaybe<Scalars['String']>;
  pattern?: InputMaybe<Scalars['String']>;
};


export type QueryExtractArgs = {
  extractid: Scalars['Int'];
};


export type QueryExtractListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  shared?: InputMaybe<Scalars['Boolean']>;
};


export type QueryItemArgs = {
  asin?: InputMaybe<Scalars['String']>;
};


export type QueryItemNamesArgs = {
  pattern?: InputMaybe<Scalars['String']>;
};


export type QueryItemsArgs = {
  fields: Scalars['JSON'];
  pattern?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};


export type QueryTestConditionArgs = {
  condition: Scalars['JSON'];
  endYm: Scalars['String'];
  startYm: Scalars['String'];
};

export enum State {
  Checking = 'CHECKING',
  Complete = 'COMPLETE',
  ErrorCheckResult = 'ERROR_CHECK_RESULT',
  ErrorExtractData = 'ERROR_EXTRACT_DATA',
  Extracting = 'EXTRACTING',
  Pending = 'PENDING',
  UserNotEnough = 'USER_NOT_ENOUGH',
  WaitForApproval = 'WAIT_FOR_APPROVAL',
  WaitForExtract = 'WAIT_FOR_EXTRACT'
}

export type User = {
  __typename?: 'User';
  companyname: Scalars['String'];
  contract_exservice: Array<ContractExservice>;
  contractid: Scalars['String'];
  menus: Array<Menu>;
  userid: Scalars['String'];
  username: Scalars['String'];
};

export enum ValidState {
  Invalid = 'INVALID',
  Valid = 'VALID',
  Warning = 'WARNING'
}

export type ItemQueryVariables = Exact<{
  asin: Scalars['String'];
}>;


export type ItemQuery = { __typename?: 'Query', item?: { __typename?: 'Item', asin: string, itemname?: string | null, listPrice?: number | null, brand?: string | null, cat1?: string | null, cat2?: string | null, cat3?: string | null, cnt: number } | null };

export type ItemsQueryVariables = Exact<{
  pattern?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
  fields: Scalars['JSON'];
}>;


export type ItemsQuery = { __typename?: 'Query', items: Array<{ __typename?: 'Item', asin: string, itemname?: string | null, listPrice?: number | null, brand?: string | null, cat1?: string | null, cat2?: string | null, cat3?: string | null, cnt: number }> };

export type ItemNamesQueryVariables = Exact<{
  pattern?: InputMaybe<Scalars['String']>;
}>;


export type ItemNamesQuery = { __typename?: 'Query', itemNames: Array<any> };

export type BrandsQueryVariables = Exact<{
  pattern?: InputMaybe<Scalars['String']>;
}>;


export type BrandsQuery = { __typename?: 'Query', brands: Array<any> };

export type CategoriesQueryVariables = Exact<{
  pattern?: InputMaybe<Scalars['String']>;
  matchType: Scalars['String'];
}>;


export type CategoriesQuery = { __typename?: 'Query', categories: Array<any> };

export type TestConditionQueryVariables = Exact<{
  startYm: Scalars['String'];
  endYm: Scalars['String'];
  condition: Scalars['JSON'];
}>;


export type TestConditionQuery = { __typename?: 'Query', testCondition: Array<any> };

export type UserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInfoQuery = { __typename?: 'Query', user?: { __typename?: 'User', userid: string, contractid: string, username: string, companyname: string, menus: Array<{ __typename?: 'Menu', menuid: string, canDownload: boolean, canStory: boolean, isTrial: boolean, contractType: string, termStart: string, termEnd: string, maxExtractSaves: number, count: number, maxCount: number }>, contract_exservice: Array<{ __typename?: 'ContractExservice', exservice: string }> } | null };

export type BasicInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type BasicInfoQuery = { __typename?: 'Query', availableMonth: { __typename?: 'AvailableMonth', yyyymm: string } };

export type ExtractListQueryVariables = Exact<{
  shared?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type ExtractListQuery = { __typename?: 'Query', extractList?: { __typename?: 'ExtractList', total: number, extracts: Array<{ __typename?: 'Extract', extractid: number, userid: string, contractid: string, title: string, startYm: string, endYm: string, condition: any, jsonVersion: string, aroundMin: number, state: State, enqversion: number, shared: boolean, enableBefAft: boolean, createdAt: any, userCount: number, user: { __typename?: 'ExtractUser', username: string } }> } | null };

export type CreateExtractMutationVariables = Exact<{
  data: ExtractInput;
}>;


export type CreateExtractMutation = { __typename?: 'Mutation', createExtract?: number | null };

export type ApproveExtractMutationVariables = Exact<{
  extractid: Scalars['Int'];
}>;


export type ApproveExtractMutation = { __typename?: 'Mutation', approveExtract: boolean };

export type DeleteExtractMutationVariables = Exact<{
  extractid: Scalars['Int'];
}>;


export type DeleteExtractMutation = { __typename?: 'Mutation', deleteExtract: boolean };

export type ShareExtractMutationVariables = Exact<{
  extractid: Scalars['Int'];
  share: Scalars['Boolean'];
}>;


export type ShareExtractMutation = { __typename?: 'Mutation', shareExtract: boolean };

export type UpdateExtractMutationVariables = Exact<{
  extractid: Scalars['Int'];
  title: Scalars['String'];
}>;


export type UpdateExtractMutation = { __typename?: 'Mutation', updateExtract: boolean };

export type ExtractInfoQueryVariables = Exact<{
  extractid: Scalars['Int'];
}>;


export type ExtractInfoQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', extractid: number, userid: string, contractid: string, title: string, startYm: string, endYm: string, condition: any, jsonVersion: string, aroundMin: number, state: State, enqversion: number, shared: boolean, enableBefAft: boolean, createdAt: any, userCount: number, user: { __typename?: 'ExtractUser', username: string }, cluster: { __typename?: 'ExtractCluster', clusters: Array<{ __typename?: 'ExtractClusterObject', clusterid: number, name: string, users: number }> } } | null };

export type UserCountQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type UserCountQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', userCount: number, pcUserCount: number, spUserCount: number, likedUserCount: number } | null };

export type UsersQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type UsersQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', users: Array<number> } | null };

export type TrendQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type TrendQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', startYm: string, endYm: string, trend: Array<{ __typename?: 'ExtractTrend', type: string, date: string, sessions: number, sessionsRate: number }> } | null };

export type GetGenderQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type GetGenderQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', avgGender?: number | null } | null };

export type GetAgeQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type GetAgeQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', avgAge?: number | null, ageBrackets: Array<{ __typename?: 'ExtractAgeBracket', ageBracket: string, usersRate: number }> } | null };

export type GetTrendQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type GetTrendQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', trend: Array<{ __typename?: 'ExtractTrend', type: string, date: string, sessions: number, sessionsRate: number }> } | null };

export type GetWeekdayHourQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type GetWeekdayHourQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', weekdayHour: Array<{ __typename?: 'ExtractWeekdayHour', weekday: number, hour: number, sessionsRate: number }> } | null };

export type WordsQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type WordsQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', words: Array<{ __typename?: 'ExtractWord', word: string, usersRate: number, femaleRate: number, age: number, score: number }> } | null };

export type SearchWordsQueryVariables = Exact<{
  extractid: Scalars['Int'];
  word: Scalars['String'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type SearchWordsQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', searchWords: Array<{ __typename?: 'ExtractSearchWord', searchWord: string, users: number }> } | null };

export type GetSitesQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type GetSitesQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', sites: Array<{ __typename?: 'ExtractSite', site: string, title?: string | null, usersRate: number, score: number }> } | null };

export type AmazonItemsQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type AmazonItemsQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', items: any } | null };

export type GetAppsQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type GetAppsQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', apps: Array<{ __typename?: 'ExtractApp', app: string, title?: string | null, usersRate: number, score: number }> } | null };

export type GenderAgeBracketsQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type GenderAgeBracketsQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', genderAgeBrackets: Array<{ __typename?: 'ExtractGenderAgeBracket', type: string, gender: string, ageBracket: string, usersRate: number }> } | null };

export type JobsQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type JobsQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', jobs: Array<{ __typename?: 'ExtractJob', type: string, job: string, usersRate: number }> } | null };

export type MarriageDataQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type MarriageDataQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', marriageData: Array<{ __typename?: 'ExtractMarriage', type: string, marriage: string, usersRate: number }> } | null };

export type ChildDataQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type ChildDataQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', childData: Array<{ __typename?: 'ExtractChild', type: string, child: string, usersRate: number }> } | null };

export type LivingAreaDataQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type LivingAreaDataQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', livingAreaData: Array<{ __typename?: 'ExtractLivingArea', type: string, livingArea: string, usersRate: number }> } | null };

export type HomeIncomeDataQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type HomeIncomeDataQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', homeIncomeData: Array<{ __typename?: 'ExtractHomeIncome', type: string, homeIncome: string, usersRate: number }> } | null };

export type FamilyDataQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type FamilyDataQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', familyData: { __typename?: 'ExtractFamily', validState: ValidState, target: Array<{ __typename?: 'ExtractFamilyRow', value: string, usersRate: number }>, monitor: Array<{ __typename?: 'ExtractFamilyRow', value: string, usersRate: number }> } } | null };

export type LivingStyleDataQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type LivingStyleDataQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', livingStyleData: { __typename?: 'ExtractLivingStyle', validState: ValidState, target: Array<{ __typename?: 'ExtractLivingStyleRow', value: string, usersRate: number }>, monitor: Array<{ __typename?: 'ExtractLivingStyleRow', value: string, usersRate: number }> } } | null };

export type MediaContactQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type MediaContactQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', tvData: { __typename?: 'ExtractMediaContact', validState: ValidState, monitor: Array<{ __typename?: 'ExtractMediaContactRow', value: string, usersRate: number }>, target: Array<{ __typename?: 'ExtractMediaContactRow', value: string, usersRate: number }> }, vodData: { __typename?: 'ExtractMediaContact', validState: ValidState, monitor: Array<{ __typename?: 'ExtractMediaContactRow', value: string, usersRate: number }>, target: Array<{ __typename?: 'ExtractMediaContactRow', value: string, usersRate: number }> }, newspaperData: { __typename?: 'ExtractMediaContact', validState: ValidState, monitor: Array<{ __typename?: 'ExtractMediaContactRow', value: string, usersRate: number }>, target: Array<{ __typename?: 'ExtractMediaContactRow', value: string, usersRate: number }> }, magazineData: { __typename?: 'ExtractMediaContact', validState: ValidState, monitor: Array<{ __typename?: 'ExtractMediaContactRow', value: string, usersRate: number }>, target: Array<{ __typename?: 'ExtractMediaContactRow', value: string, usersRate: number }> }, ebookData: { __typename?: 'ExtractMediaContact', validState: ValidState, monitor: Array<{ __typename?: 'ExtractMediaContactRow', value: string, usersRate: number }>, target: Array<{ __typename?: 'ExtractMediaContactRow', value: string, usersRate: number }> }, radioData: { __typename?: 'ExtractMediaContact', validState: ValidState, monitor: Array<{ __typename?: 'ExtractMediaContactRow', value: string, usersRate: number }>, target: Array<{ __typename?: 'ExtractMediaContactRow', value: string, usersRate: number }> } } | null };

export type AppUsageQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type AppUsageQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', lineData: { __typename?: 'ExtractAppUsage', validState: ValidState, monitor: Array<{ __typename?: 'ExtractAppUsageRow', value: string, usersRate: number }>, target: Array<{ __typename?: 'ExtractAppUsageRow', value: string, usersRate: number }> }, twitterData: { __typename?: 'ExtractAppUsage', validState: ValidState, monitor: Array<{ __typename?: 'ExtractAppUsageRow', value: string, usersRate: number }>, target: Array<{ __typename?: 'ExtractAppUsageRow', value: string, usersRate: number }> }, facebookData: { __typename?: 'ExtractAppUsage', validState: ValidState, monitor: Array<{ __typename?: 'ExtractAppUsageRow', value: string, usersRate: number }>, target: Array<{ __typename?: 'ExtractAppUsageRow', value: string, usersRate: number }> }, instagramData: { __typename?: 'ExtractAppUsage', validState: ValidState, monitor: Array<{ __typename?: 'ExtractAppUsageRow', value: string, usersRate: number }>, target: Array<{ __typename?: 'ExtractAppUsageRow', value: string, usersRate: number }> }, yahooData: { __typename?: 'ExtractAppUsage', validState: ValidState, monitor: Array<{ __typename?: 'ExtractAppUsageRow', value: string, usersRate: number }>, target: Array<{ __typename?: 'ExtractAppUsageRow', value: string, usersRate: number }> }, newsData: { __typename?: 'ExtractAppUsage', validState: ValidState, monitor: Array<{ __typename?: 'ExtractAppUsageRow', value: string, usersRate: number }>, target: Array<{ __typename?: 'ExtractAppUsageRow', value: string, usersRate: number }> }, gameData: { __typename?: 'ExtractAppUsage', validState: ValidState, monitor: Array<{ __typename?: 'ExtractAppUsageRow', value: string, usersRate: number }>, target: Array<{ __typename?: 'ExtractAppUsageRow', value: string, usersRate: number }> }, videoData: { __typename?: 'ExtractAppUsage', validState: ValidState, monitor: Array<{ __typename?: 'ExtractAppUsageRow', value: string, usersRate: number }>, target: Array<{ __typename?: 'ExtractAppUsageRow', value: string, usersRate: number }> } } | null };

export type ShoppingQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type ShoppingQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', channel: { __typename?: 'ExtractShopping', validState: ValidState, monitor: Array<{ __typename?: 'ExtractShoppingRow', value: string, usersRate: number }>, target: Array<{ __typename?: 'ExtractShoppingRow', value: string, usersRate: number }> }, behavior: { __typename?: 'ExtractShopping', validState: ValidState, monitor: Array<{ __typename?: 'ExtractShoppingRow', value: string, usersRate: number }>, target: Array<{ __typename?: 'ExtractShoppingRow', value: string, usersRate: number }> }, measure: { __typename?: 'ExtractShopping', validState: ValidState, monitor: Array<{ __typename?: 'ExtractShoppingRow', value: string, usersRate: number }>, target: Array<{ __typename?: 'ExtractShoppingRow', value: string, usersRate: number }> }, point: { __typename?: 'ExtractShopping', validState: ValidState, monitor: Array<{ __typename?: 'ExtractShoppingRow', value: string, usersRate: number }>, target: Array<{ __typename?: 'ExtractShoppingRow', value: string, usersRate: number }> } } | null };

export type AssetsQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type AssetsQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', disposableIncome: { __typename?: 'ExtractDisposableIncome', validState: ValidState, monitor: Array<{ __typename?: 'ExtractDisposableIncomeRow', value: string, usersRate: number }>, target: Array<{ __typename?: 'ExtractDisposableIncomeRow', value: string, usersRate: number }> }, ownedAssets: { __typename?: 'ExtractOwnedAssets', validState: ValidState, monitor: Array<{ __typename?: 'ExtractOwnedAssetsRow', value: string, usersRate: number }>, target: Array<{ __typename?: 'ExtractOwnedAssetsRow', value: string, usersRate: number }> }, spending: { __typename?: 'ExtractSpending', validState: ValidState, monitor: Array<{ __typename?: 'ExtractSpendingRow', spending: string, amount: number }>, target: Array<{ __typename?: 'ExtractSpendingRow', spending: string, amount: number }> } } | null };

export type InterestQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type InterestQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', interest: { __typename?: 'ExtractInterest', validState: ValidState, interests: Array<{ __typename?: 'ExtractInterestRow', interest: string, usersRate: number, score: number }> } } | null };

export type BodyTroubleQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type BodyTroubleQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', bodyCare: { __typename?: 'ExtractBodyTrouble', validState: ValidState, data: Array<{ __typename?: 'ExtractBodyTroubleRow', bodyTrouble: string, usersRate: number, score: number }> }, bodyMeasure: { __typename?: 'ExtractBodyTrouble', validState: ValidState, data: Array<{ __typename?: 'ExtractBodyTroubleRow', bodyTrouble: string, usersRate: number, score: number }> } } | null };

export type SportsQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type SportsQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', sportsWatch: { __typename?: 'ExtractSports', validState: ValidState, data: Array<{ __typename?: 'ExtractSportsRow', sports: string, usersRate: number, score: number }> }, sportsPlay: { __typename?: 'ExtractSports', validState: ValidState, data: Array<{ __typename?: 'ExtractSportsRow', sports: string, usersRate: number, score: number }> } } | null };

export type SiteRankingQueryVariables = Exact<{
  extractid: Scalars['Int'];
  siteCategories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type SiteRankingQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', sites: Array<{ __typename?: 'ExtractSite', site: string, title?: string | null, siteCategory?: string | null, usersRate: number, score: number }> } | null };

export type AppRankingQueryVariables = Exact<{
  extractid: Scalars['Int'];
  appCategories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type AppRankingQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', apps: Array<{ __typename?: 'ExtractApp', app: string, title?: string | null, category?: string | null, usersRate: number, score: number }> } | null };

export type WordRankingQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type WordRankingQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', words: Array<{ __typename?: 'ExtractWord', word: string, usersRate: number, femaleRate: number, age: number, score: number }> } | null };

export type UserListQueryVariables = Exact<{
  extractid: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  liked?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type UserListQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', userList: { __typename?: 'ExtractUserList', users: Array<{ __typename?: 'ExtractUserRow', extractuserid: number, vid: string, dbname: string, gender: string, ageBracket: string, marriage: string, child: string, prefecture: string, homeIncome?: string | null, job?: string | null, clusterid?: number | null, note?: string | null, blocks?: number | null, liked: number, likes: number }> } } | null };

export type UserWordsQueryVariables = Exact<{
  extractid: Scalars['Int'];
  extractuserid: Scalars['Int'];
  siteCategory?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type UserWordsQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', userList: { __typename?: 'ExtractUserList', userWords: Array<{ __typename?: 'ExtractUserWordRow', word: string, cnt: number }> } } | null };

export type UserSessionsQueryVariables = Exact<{
  extractid: Scalars['Int'];
  extractuserid: Scalars['Int'];
  siteCategory?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  appCategory?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
  withApp?: InputMaybe<Scalars['Boolean']>;
  withItem?: InputMaybe<Scalars['Boolean']>;
}>;


export type UserSessionsQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', userList: { __typename?: 'ExtractUserList', sessions: Array<{ __typename?: 'ExtractUserSessionRow', row: number, type: string, extractuserid: number, extractsessionid: number, blockid: number, base: boolean, accessTime: any, site?: string | null, url: string, title?: string | null, pv: number, timeOn: number, refCatName: string, refKeyword: string, refUrl: string, filter?: number | null, comment?: string | null }> } } | null };

export type UserSiteCategoriesQueryVariables = Exact<{
  extractid: Scalars['Int'];
  extractuserid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type UserSiteCategoriesQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', userList: { __typename?: 'ExtractUserList', siteCategories: any } } | null };

export type UserAppCategoriesQueryVariables = Exact<{
  extractid: Scalars['Int'];
  extractuserid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type UserAppCategoriesQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', userList: { __typename?: 'ExtractUserList', appCategories: any } } | null };

export type NoteQueryVariables = Exact<{
  extractid: Scalars['Int'];
  extractuserid: Scalars['Int'];
}>;


export type NoteQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', userList: { __typename?: 'ExtractUserList', note: string } } | null };

export type UpdateNoteMutationVariables = Exact<{
  extractid: Scalars['Int'];
  extractuserid: Scalars['Int'];
  note: Scalars['String'];
}>;


export type UpdateNoteMutation = { __typename?: 'Mutation', updateNote: boolean };

export type UpdateCommentMutationVariables = Exact<{
  extractid: Scalars['Int'];
  extractuserid: Scalars['Int'];
  extractsessionid: Scalars['Int'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCommentMutation = { __typename?: 'Mutation', updateComment: boolean };

export type UpdateLikedMutationVariables = Exact<{
  extractid: Scalars['Int'];
  extractuserid: Scalars['Int'];
  liked: Scalars['Boolean'];
}>;


export type UpdateLikedMutation = { __typename?: 'Mutation', updateLiked: boolean };

export type ExecuteClusterMutationVariables = Exact<{
  extractid: Scalars['Int'];
  clusterNum: Scalars['Int'];
  userids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type ExecuteClusterMutation = { __typename?: 'Mutation', executeCluster: boolean };

export type ClusterStateQueryVariables = Exact<{
  extractid: Scalars['Int'];
}>;


export type ClusterStateQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', cluster: { __typename?: 'ExtractCluster', state: ClusterState } } | null };

export type ClustersQueryVariables = Exact<{
  extractid: Scalars['Int'];
}>;


export type ClustersQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', cluster: { __typename?: 'ExtractCluster', clusters: Array<{ __typename?: 'ExtractClusterObject', clusterid: number, name: string, users: number }> } } | null };

export type ClusterWordsQueryVariables = Exact<{
  extractid: Scalars['Int'];
}>;


export type ClusterWordsQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', cluster: { __typename?: 'ExtractCluster', clusters: Array<{ __typename?: 'ExtractClusterObject', clusterid: number, name: string, users: number, words: Array<{ __typename?: 'ExtractClusterWord', word: string, score: number }> }> } } | null };

export type ClusterSitesQueryVariables = Exact<{
  extractid: Scalars['Int'];
}>;


export type ClusterSitesQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', cluster: { __typename?: 'ExtractCluster', clusters: Array<{ __typename?: 'ExtractClusterObject', clusterid: number, name: string, users: number, sites: Array<{ __typename?: 'ExtractClusterSite', site: string, title?: string | null, score: number }> }> } } | null };

export type StopwordsQueryVariables = Exact<{
  extractid: Scalars['Int'];
}>;


export type StopwordsQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', cluster: { __typename?: 'ExtractCluster', stopwords: Array<string> } } | null };

export type UpdateStopwordsMutationVariables = Exact<{
  extractid: Scalars['Int'];
  stopwords: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateStopwordsMutation = { __typename?: 'Mutation', updateStopwords: boolean };

export type UpdateClusterNameMutationVariables = Exact<{
  extractid: Scalars['Int'];
  clusterid: Scalars['Int'];
  name: Scalars['String'];
}>;


export type UpdateClusterNameMutation = { __typename?: 'Mutation', updateClusterName: boolean };

export type ClusterAttributesQueryVariables = Exact<{
  extractid: Scalars['Int'];
}>;


export type ClusterAttributesQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', clusterAttributes?: any | null, clusterDisposableIncome?: any | null, clusterOwnedAssets?: any | null } | null };

export type ClusterFamilyQueryVariables = Exact<{
  extractid: Scalars['Int'];
}>;


export type ClusterFamilyQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', clusterFamily?: any | null } | null };

export type ClusterLivingStyleQueryVariables = Exact<{
  extractid: Scalars['Int'];
}>;


export type ClusterLivingStyleQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', clusterLivingStyle?: any | null } | null };

export type ClusterMediaContactQueryVariables = Exact<{
  extractid: Scalars['Int'];
}>;


export type ClusterMediaContactQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', clusterMediaContact?: any | null } | null };

export type ClusterAppUsageQueryVariables = Exact<{
  extractid: Scalars['Int'];
}>;


export type ClusterAppUsageQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', clusterAppUsage?: any | null } | null };

export type AttributesQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
  site?: InputMaybe<Scalars['String']>;
  word?: InputMaybe<Scalars['String']>;
  app?: InputMaybe<Scalars['String']>;
}>;


export type AttributesQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', general: { __typename?: 'ExtractGeneral', attributes?: any | null } } | null };

export type GeneralTrendQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
  site?: InputMaybe<Scalars['String']>;
  word?: InputMaybe<Scalars['String']>;
  app?: InputMaybe<Scalars['String']>;
}>;


export type GeneralTrendQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', general: { __typename?: 'ExtractGeneral', trend?: any | null } } | null };

export type GeneralWordsQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
  split: Scalars['Boolean'];
  site?: InputMaybe<Scalars['String']>;
  word?: InputMaybe<Scalars['String']>;
  befaft?: InputMaybe<Scalars['Int']>;
}>;


export type GeneralWordsQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', general: { __typename?: 'ExtractGeneral', words?: any | null } } | null };

export type GeneralSitesQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
  site?: InputMaybe<Scalars['String']>;
  word?: InputMaybe<Scalars['String']>;
  befaft?: InputMaybe<Scalars['Int']>;
}>;


export type GeneralSitesQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', general: { __typename?: 'ExtractGeneral', sites?: any | null } } | null };

export type GeneralLandingPagesQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
  site?: InputMaybe<Scalars['String']>;
  word?: InputMaybe<Scalars['String']>;
  befaft?: InputMaybe<Scalars['Int']>;
}>;


export type GeneralLandingPagesQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', general: { __typename?: 'ExtractGeneral', landingPages?: any | null } } | null };

export type BeforeAfterQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
  beforeAfter: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type BeforeAfterQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', beforeAfter: Array<any> } | null };

export type BeforeAfterWordQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
  beforeAfter: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type BeforeAfterWordQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', beforeAfterWord: Array<any> } | null };

export type BeforeAfterAppQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
  beforeAfter: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type BeforeAfterAppQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', beforeAfterApp: Array<any> } | null };

export type BeforeAfterSankeyQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
  beforeAfter: Scalars['Int'];
  site?: InputMaybe<Scalars['String']>;
  word?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type BeforeAfterSankeyQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', beforeAfterSankey: Array<any> } | null };

export type CanExtractMutationVariables = Exact<{ [key: string]: never; }>;


export type CanExtractMutation = { __typename?: 'Mutation', canExtract: boolean };

export type HitCountQueryVariables = Exact<{
  extractid: Scalars['Int'];
  filter?: InputMaybe<ExtractFilter>;
  clusterid?: InputMaybe<Scalars['Int']>;
}>;


export type HitCountQuery = { __typename?: 'Query', extract?: { __typename?: 'Extract', hitCount: Array<any> } | null };


export const ItemDocument = gql`
    query item($asin: String!) {
  item(asin: $asin) {
    asin
    itemname
    listPrice
    brand
    cat1
    cat2
    cat3
    cnt
  }
}
    `;

/**
 * __useItemQuery__
 *
 * To run a query within a React component, call `useItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemQuery({
 *   variables: {
 *      asin: // value for 'asin'
 *   },
 * });
 */
export function useItemQuery(baseOptions: Apollo.QueryHookOptions<ItemQuery, ItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemQuery, ItemQueryVariables>(ItemDocument, options);
      }
export function useItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemQuery, ItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemQuery, ItemQueryVariables>(ItemDocument, options);
        }
export type ItemQueryHookResult = ReturnType<typeof useItemQuery>;
export type ItemLazyQueryHookResult = ReturnType<typeof useItemLazyQuery>;
export type ItemQueryResult = Apollo.QueryResult<ItemQuery, ItemQueryVariables>;
export const ItemsDocument = gql`
    query items($pattern: String, $value: String, $fields: JSON!) {
  items(pattern: $pattern, value: $value, fields: $fields) {
    asin
    itemname
    listPrice
    brand
    cat1
    cat2
    cat3
    cnt
  }
}
    `;

/**
 * __useItemsQuery__
 *
 * To run a query within a React component, call `useItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsQuery({
 *   variables: {
 *      pattern: // value for 'pattern'
 *      value: // value for 'value'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useItemsQuery(baseOptions: Apollo.QueryHookOptions<ItemsQuery, ItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemsQuery, ItemsQueryVariables>(ItemsDocument, options);
      }
export function useItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemsQuery, ItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemsQuery, ItemsQueryVariables>(ItemsDocument, options);
        }
export type ItemsQueryHookResult = ReturnType<typeof useItemsQuery>;
export type ItemsLazyQueryHookResult = ReturnType<typeof useItemsLazyQuery>;
export type ItemsQueryResult = Apollo.QueryResult<ItemsQuery, ItemsQueryVariables>;
export const ItemNamesDocument = gql`
    query itemNames($pattern: String) {
  itemNames(pattern: $pattern)
}
    `;

/**
 * __useItemNamesQuery__
 *
 * To run a query within a React component, call `useItemNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemNamesQuery({
 *   variables: {
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useItemNamesQuery(baseOptions?: Apollo.QueryHookOptions<ItemNamesQuery, ItemNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemNamesQuery, ItemNamesQueryVariables>(ItemNamesDocument, options);
      }
export function useItemNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemNamesQuery, ItemNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemNamesQuery, ItemNamesQueryVariables>(ItemNamesDocument, options);
        }
export type ItemNamesQueryHookResult = ReturnType<typeof useItemNamesQuery>;
export type ItemNamesLazyQueryHookResult = ReturnType<typeof useItemNamesLazyQuery>;
export type ItemNamesQueryResult = Apollo.QueryResult<ItemNamesQuery, ItemNamesQueryVariables>;
export const BrandsDocument = gql`
    query brands($pattern: String) {
  brands(pattern: $pattern)
}
    `;

/**
 * __useBrandsQuery__
 *
 * To run a query within a React component, call `useBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandsQuery({
 *   variables: {
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useBrandsQuery(baseOptions?: Apollo.QueryHookOptions<BrandsQuery, BrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandsQuery, BrandsQueryVariables>(BrandsDocument, options);
      }
export function useBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandsQuery, BrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandsQuery, BrandsQueryVariables>(BrandsDocument, options);
        }
export type BrandsQueryHookResult = ReturnType<typeof useBrandsQuery>;
export type BrandsLazyQueryHookResult = ReturnType<typeof useBrandsLazyQuery>;
export type BrandsQueryResult = Apollo.QueryResult<BrandsQuery, BrandsQueryVariables>;
export const CategoriesDocument = gql`
    query categories($pattern: String, $matchType: String!) {
  categories(pattern: $pattern, matchType: $matchType)
}
    `;

/**
 * __useCategoriesQuery__
 *
 * To run a query within a React component, call `useCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesQuery({
 *   variables: {
 *      pattern: // value for 'pattern'
 *      matchType: // value for 'matchType'
 *   },
 * });
 */
export function useCategoriesQuery(baseOptions: Apollo.QueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
      }
export function useCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
        }
export type CategoriesQueryHookResult = ReturnType<typeof useCategoriesQuery>;
export type CategoriesLazyQueryHookResult = ReturnType<typeof useCategoriesLazyQuery>;
export type CategoriesQueryResult = Apollo.QueryResult<CategoriesQuery, CategoriesQueryVariables>;
export const TestConditionDocument = gql`
    query testCondition($startYm: String!, $endYm: String!, $condition: JSON!) {
  testCondition(startYm: $startYm, endYm: $endYm, condition: $condition)
}
    `;

/**
 * __useTestConditionQuery__
 *
 * To run a query within a React component, call `useTestConditionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestConditionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestConditionQuery({
 *   variables: {
 *      startYm: // value for 'startYm'
 *      endYm: // value for 'endYm'
 *      condition: // value for 'condition'
 *   },
 * });
 */
export function useTestConditionQuery(baseOptions: Apollo.QueryHookOptions<TestConditionQuery, TestConditionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestConditionQuery, TestConditionQueryVariables>(TestConditionDocument, options);
      }
export function useTestConditionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestConditionQuery, TestConditionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestConditionQuery, TestConditionQueryVariables>(TestConditionDocument, options);
        }
export type TestConditionQueryHookResult = ReturnType<typeof useTestConditionQuery>;
export type TestConditionLazyQueryHookResult = ReturnType<typeof useTestConditionLazyQuery>;
export type TestConditionQueryResult = Apollo.QueryResult<TestConditionQuery, TestConditionQueryVariables>;
export const UserInfoDocument = gql`
    query userInfo {
  user {
    userid
    contractid
    username
    companyname
    menus {
      menuid
      canDownload
      canStory
      isTrial
      contractType
      termStart
      termEnd
      maxExtractSaves
      count
      maxCount
    }
    contract_exservice {
      exservice
    }
  }
}
    `;

/**
 * __useUserInfoQuery__
 *
 * To run a query within a React component, call `useUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserInfoQuery(baseOptions?: Apollo.QueryHookOptions<UserInfoQuery, UserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserInfoQuery, UserInfoQueryVariables>(UserInfoDocument, options);
      }
export function useUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserInfoQuery, UserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserInfoQuery, UserInfoQueryVariables>(UserInfoDocument, options);
        }
export type UserInfoQueryHookResult = ReturnType<typeof useUserInfoQuery>;
export type UserInfoLazyQueryHookResult = ReturnType<typeof useUserInfoLazyQuery>;
export type UserInfoQueryResult = Apollo.QueryResult<UserInfoQuery, UserInfoQueryVariables>;
export const BasicInfoDocument = gql`
    query basicInfo {
  availableMonth {
    yyyymm
  }
}
    `;

/**
 * __useBasicInfoQuery__
 *
 * To run a query within a React component, call `useBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useBasicInfoQuery(baseOptions?: Apollo.QueryHookOptions<BasicInfoQuery, BasicInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BasicInfoQuery, BasicInfoQueryVariables>(BasicInfoDocument, options);
      }
export function useBasicInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BasicInfoQuery, BasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BasicInfoQuery, BasicInfoQueryVariables>(BasicInfoDocument, options);
        }
export type BasicInfoQueryHookResult = ReturnType<typeof useBasicInfoQuery>;
export type BasicInfoLazyQueryHookResult = ReturnType<typeof useBasicInfoLazyQuery>;
export type BasicInfoQueryResult = Apollo.QueryResult<BasicInfoQuery, BasicInfoQueryVariables>;
export const ExtractListDocument = gql`
    query extractList($shared: Boolean, $offset: Int, $limit: Int) {
  extractList(shared: $shared, offset: $offset, limit: $limit) {
    total
    extracts {
      extractid
      userid
      contractid
      user {
        username
      }
      title
      startYm
      endYm
      condition
      jsonVersion
      aroundMin
      state
      enqversion
      shared
      enableBefAft
      createdAt
      userCount
    }
  }
}
    `;

/**
 * __useExtractListQuery__
 *
 * To run a query within a React component, call `useExtractListQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtractListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtractListQuery({
 *   variables: {
 *      shared: // value for 'shared'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useExtractListQuery(baseOptions?: Apollo.QueryHookOptions<ExtractListQuery, ExtractListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtractListQuery, ExtractListQueryVariables>(ExtractListDocument, options);
      }
export function useExtractListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtractListQuery, ExtractListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtractListQuery, ExtractListQueryVariables>(ExtractListDocument, options);
        }
export type ExtractListQueryHookResult = ReturnType<typeof useExtractListQuery>;
export type ExtractListLazyQueryHookResult = ReturnType<typeof useExtractListLazyQuery>;
export type ExtractListQueryResult = Apollo.QueryResult<ExtractListQuery, ExtractListQueryVariables>;
export const CreateExtractDocument = gql`
    mutation createExtract($data: ExtractInput!) {
  createExtract(data: $data)
}
    `;
export type CreateExtractMutationFn = Apollo.MutationFunction<CreateExtractMutation, CreateExtractMutationVariables>;

/**
 * __useCreateExtractMutation__
 *
 * To run a mutation, you first call `useCreateExtractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExtractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExtractMutation, { data, loading, error }] = useCreateExtractMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateExtractMutation(baseOptions?: Apollo.MutationHookOptions<CreateExtractMutation, CreateExtractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExtractMutation, CreateExtractMutationVariables>(CreateExtractDocument, options);
      }
export type CreateExtractMutationHookResult = ReturnType<typeof useCreateExtractMutation>;
export type CreateExtractMutationResult = Apollo.MutationResult<CreateExtractMutation>;
export type CreateExtractMutationOptions = Apollo.BaseMutationOptions<CreateExtractMutation, CreateExtractMutationVariables>;
export const ApproveExtractDocument = gql`
    mutation approveExtract($extractid: Int!) {
  approveExtract(extractid: $extractid)
}
    `;
export type ApproveExtractMutationFn = Apollo.MutationFunction<ApproveExtractMutation, ApproveExtractMutationVariables>;

/**
 * __useApproveExtractMutation__
 *
 * To run a mutation, you first call `useApproveExtractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveExtractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveExtractMutation, { data, loading, error }] = useApproveExtractMutation({
 *   variables: {
 *      extractid: // value for 'extractid'
 *   },
 * });
 */
export function useApproveExtractMutation(baseOptions?: Apollo.MutationHookOptions<ApproveExtractMutation, ApproveExtractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveExtractMutation, ApproveExtractMutationVariables>(ApproveExtractDocument, options);
      }
export type ApproveExtractMutationHookResult = ReturnType<typeof useApproveExtractMutation>;
export type ApproveExtractMutationResult = Apollo.MutationResult<ApproveExtractMutation>;
export type ApproveExtractMutationOptions = Apollo.BaseMutationOptions<ApproveExtractMutation, ApproveExtractMutationVariables>;
export const DeleteExtractDocument = gql`
    mutation deleteExtract($extractid: Int!) {
  deleteExtract(extractid: $extractid)
}
    `;
export type DeleteExtractMutationFn = Apollo.MutationFunction<DeleteExtractMutation, DeleteExtractMutationVariables>;

/**
 * __useDeleteExtractMutation__
 *
 * To run a mutation, you first call `useDeleteExtractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExtractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExtractMutation, { data, loading, error }] = useDeleteExtractMutation({
 *   variables: {
 *      extractid: // value for 'extractid'
 *   },
 * });
 */
export function useDeleteExtractMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExtractMutation, DeleteExtractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExtractMutation, DeleteExtractMutationVariables>(DeleteExtractDocument, options);
      }
export type DeleteExtractMutationHookResult = ReturnType<typeof useDeleteExtractMutation>;
export type DeleteExtractMutationResult = Apollo.MutationResult<DeleteExtractMutation>;
export type DeleteExtractMutationOptions = Apollo.BaseMutationOptions<DeleteExtractMutation, DeleteExtractMutationVariables>;
export const ShareExtractDocument = gql`
    mutation shareExtract($extractid: Int!, $share: Boolean!) {
  shareExtract(extractid: $extractid, share: $share)
}
    `;
export type ShareExtractMutationFn = Apollo.MutationFunction<ShareExtractMutation, ShareExtractMutationVariables>;

/**
 * __useShareExtractMutation__
 *
 * To run a mutation, you first call `useShareExtractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareExtractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareExtractMutation, { data, loading, error }] = useShareExtractMutation({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      share: // value for 'share'
 *   },
 * });
 */
export function useShareExtractMutation(baseOptions?: Apollo.MutationHookOptions<ShareExtractMutation, ShareExtractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareExtractMutation, ShareExtractMutationVariables>(ShareExtractDocument, options);
      }
export type ShareExtractMutationHookResult = ReturnType<typeof useShareExtractMutation>;
export type ShareExtractMutationResult = Apollo.MutationResult<ShareExtractMutation>;
export type ShareExtractMutationOptions = Apollo.BaseMutationOptions<ShareExtractMutation, ShareExtractMutationVariables>;
export const UpdateExtractDocument = gql`
    mutation updateExtract($extractid: Int!, $title: String!) {
  updateExtract(extractid: $extractid, title: $title)
}
    `;
export type UpdateExtractMutationFn = Apollo.MutationFunction<UpdateExtractMutation, UpdateExtractMutationVariables>;

/**
 * __useUpdateExtractMutation__
 *
 * To run a mutation, you first call `useUpdateExtractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExtractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExtractMutation, { data, loading, error }] = useUpdateExtractMutation({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateExtractMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExtractMutation, UpdateExtractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExtractMutation, UpdateExtractMutationVariables>(UpdateExtractDocument, options);
      }
export type UpdateExtractMutationHookResult = ReturnType<typeof useUpdateExtractMutation>;
export type UpdateExtractMutationResult = Apollo.MutationResult<UpdateExtractMutation>;
export type UpdateExtractMutationOptions = Apollo.BaseMutationOptions<UpdateExtractMutation, UpdateExtractMutationVariables>;
export const ExtractInfoDocument = gql`
    query extractInfo($extractid: Int!) {
  extract(extractid: $extractid) {
    extractid
    userid
    contractid
    user {
      username
    }
    title
    startYm
    endYm
    condition
    jsonVersion
    aroundMin
    state
    enqversion
    shared
    enableBefAft
    createdAt
    userCount
    cluster {
      clusters {
        clusterid
        name
        users
      }
    }
  }
}
    `;

/**
 * __useExtractInfoQuery__
 *
 * To run a query within a React component, call `useExtractInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtractInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtractInfoQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *   },
 * });
 */
export function useExtractInfoQuery(baseOptions: Apollo.QueryHookOptions<ExtractInfoQuery, ExtractInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtractInfoQuery, ExtractInfoQueryVariables>(ExtractInfoDocument, options);
      }
export function useExtractInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtractInfoQuery, ExtractInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtractInfoQuery, ExtractInfoQueryVariables>(ExtractInfoDocument, options);
        }
export type ExtractInfoQueryHookResult = ReturnType<typeof useExtractInfoQuery>;
export type ExtractInfoLazyQueryHookResult = ReturnType<typeof useExtractInfoLazyQuery>;
export type ExtractInfoQueryResult = Apollo.QueryResult<ExtractInfoQuery, ExtractInfoQueryVariables>;
export const UserCountDocument = gql`
    query userCount($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    userCount(filter: $filter, clusterid: $clusterid)
    pcUserCount: userCount(device: PC, filter: $filter, clusterid: $clusterid)
    spUserCount: userCount(device: SP, filter: $filter, clusterid: $clusterid)
    likedUserCount: userCount(liked: true, filter: $filter, clusterid: $clusterid)
  }
}
    `;

/**
 * __useUserCountQuery__
 *
 * To run a query within a React component, call `useUserCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCountQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useUserCountQuery(baseOptions: Apollo.QueryHookOptions<UserCountQuery, UserCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCountQuery, UserCountQueryVariables>(UserCountDocument, options);
      }
export function useUserCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCountQuery, UserCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCountQuery, UserCountQueryVariables>(UserCountDocument, options);
        }
export type UserCountQueryHookResult = ReturnType<typeof useUserCountQuery>;
export type UserCountLazyQueryHookResult = ReturnType<typeof useUserCountLazyQuery>;
export type UserCountQueryResult = Apollo.QueryResult<UserCountQuery, UserCountQueryVariables>;
export const UsersDocument = gql`
    query users($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    users(filter: $filter, clusterid: $clusterid)
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useUsersQuery(baseOptions: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const TrendDocument = gql`
    query trend($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    startYm
    endYm
    trend(dateGroup: MONTH, filter: $filter, clusterid: $clusterid) {
      type
      date
      sessions
      sessionsRate
    }
  }
}
    `;

/**
 * __useTrendQuery__
 *
 * To run a query within a React component, call `useTrendQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrendQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useTrendQuery(baseOptions: Apollo.QueryHookOptions<TrendQuery, TrendQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrendQuery, TrendQueryVariables>(TrendDocument, options);
      }
export function useTrendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrendQuery, TrendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrendQuery, TrendQueryVariables>(TrendDocument, options);
        }
export type TrendQueryHookResult = ReturnType<typeof useTrendQuery>;
export type TrendLazyQueryHookResult = ReturnType<typeof useTrendLazyQuery>;
export type TrendQueryResult = Apollo.QueryResult<TrendQuery, TrendQueryVariables>;
export const GetGenderDocument = gql`
    query getGender($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    avgGender(filter: $filter, clusterid: $clusterid)
  }
}
    `;

/**
 * __useGetGenderQuery__
 *
 * To run a query within a React component, call `useGetGenderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenderQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useGetGenderQuery(baseOptions: Apollo.QueryHookOptions<GetGenderQuery, GetGenderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenderQuery, GetGenderQueryVariables>(GetGenderDocument, options);
      }
export function useGetGenderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenderQuery, GetGenderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenderQuery, GetGenderQueryVariables>(GetGenderDocument, options);
        }
export type GetGenderQueryHookResult = ReturnType<typeof useGetGenderQuery>;
export type GetGenderLazyQueryHookResult = ReturnType<typeof useGetGenderLazyQuery>;
export type GetGenderQueryResult = Apollo.QueryResult<GetGenderQuery, GetGenderQueryVariables>;
export const GetAgeDocument = gql`
    query getAge($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    avgAge(filter: $filter, clusterid: $clusterid)
    ageBrackets(filter: $filter, clusterid: $clusterid) {
      ageBracket
      usersRate
    }
  }
}
    `;

/**
 * __useGetAgeQuery__
 *
 * To run a query within a React component, call `useGetAgeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgeQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useGetAgeQuery(baseOptions: Apollo.QueryHookOptions<GetAgeQuery, GetAgeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgeQuery, GetAgeQueryVariables>(GetAgeDocument, options);
      }
export function useGetAgeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgeQuery, GetAgeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgeQuery, GetAgeQueryVariables>(GetAgeDocument, options);
        }
export type GetAgeQueryHookResult = ReturnType<typeof useGetAgeQuery>;
export type GetAgeLazyQueryHookResult = ReturnType<typeof useGetAgeLazyQuery>;
export type GetAgeQueryResult = Apollo.QueryResult<GetAgeQuery, GetAgeQueryVariables>;
export const GetTrendDocument = gql`
    query getTrend($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    trend(dateGroup: WEEK, filter: $filter, clusterid: $clusterid) {
      type
      date
      sessions
      sessionsRate
    }
  }
}
    `;

/**
 * __useGetTrendQuery__
 *
 * To run a query within a React component, call `useGetTrendQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useGetTrendQuery(baseOptions: Apollo.QueryHookOptions<GetTrendQuery, GetTrendQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrendQuery, GetTrendQueryVariables>(GetTrendDocument, options);
      }
export function useGetTrendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrendQuery, GetTrendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrendQuery, GetTrendQueryVariables>(GetTrendDocument, options);
        }
export type GetTrendQueryHookResult = ReturnType<typeof useGetTrendQuery>;
export type GetTrendLazyQueryHookResult = ReturnType<typeof useGetTrendLazyQuery>;
export type GetTrendQueryResult = Apollo.QueryResult<GetTrendQuery, GetTrendQueryVariables>;
export const GetWeekdayHourDocument = gql`
    query getWeekdayHour($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    weekdayHour(filter: $filter, clusterid: $clusterid) {
      weekday
      hour
      sessionsRate
    }
  }
}
    `;

/**
 * __useGetWeekdayHourQuery__
 *
 * To run a query within a React component, call `useGetWeekdayHourQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWeekdayHourQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWeekdayHourQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useGetWeekdayHourQuery(baseOptions: Apollo.QueryHookOptions<GetWeekdayHourQuery, GetWeekdayHourQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWeekdayHourQuery, GetWeekdayHourQueryVariables>(GetWeekdayHourDocument, options);
      }
export function useGetWeekdayHourLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWeekdayHourQuery, GetWeekdayHourQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWeekdayHourQuery, GetWeekdayHourQueryVariables>(GetWeekdayHourDocument, options);
        }
export type GetWeekdayHourQueryHookResult = ReturnType<typeof useGetWeekdayHourQuery>;
export type GetWeekdayHourLazyQueryHookResult = ReturnType<typeof useGetWeekdayHourLazyQuery>;
export type GetWeekdayHourQueryResult = Apollo.QueryResult<GetWeekdayHourQuery, GetWeekdayHourQueryVariables>;
export const WordsDocument = gql`
    query words($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    words(filter: $filter, clusterid: $clusterid) {
      word
      usersRate
      femaleRate
      age
      score
    }
  }
}
    `;

/**
 * __useWordsQuery__
 *
 * To run a query within a React component, call `useWordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWordsQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useWordsQuery(baseOptions: Apollo.QueryHookOptions<WordsQuery, WordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WordsQuery, WordsQueryVariables>(WordsDocument, options);
      }
export function useWordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WordsQuery, WordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WordsQuery, WordsQueryVariables>(WordsDocument, options);
        }
export type WordsQueryHookResult = ReturnType<typeof useWordsQuery>;
export type WordsLazyQueryHookResult = ReturnType<typeof useWordsLazyQuery>;
export type WordsQueryResult = Apollo.QueryResult<WordsQuery, WordsQueryVariables>;
export const SearchWordsDocument = gql`
    query searchWords($extractid: Int!, $word: String!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    searchWords(word: $word, filter: $filter, clusterid: $clusterid) {
      searchWord
      users
    }
  }
}
    `;

/**
 * __useSearchWordsQuery__
 *
 * To run a query within a React component, call `useSearchWordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchWordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchWordsQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      word: // value for 'word'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useSearchWordsQuery(baseOptions: Apollo.QueryHookOptions<SearchWordsQuery, SearchWordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchWordsQuery, SearchWordsQueryVariables>(SearchWordsDocument, options);
      }
export function useSearchWordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchWordsQuery, SearchWordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchWordsQuery, SearchWordsQueryVariables>(SearchWordsDocument, options);
        }
export type SearchWordsQueryHookResult = ReturnType<typeof useSearchWordsQuery>;
export type SearchWordsLazyQueryHookResult = ReturnType<typeof useSearchWordsLazyQuery>;
export type SearchWordsQueryResult = Apollo.QueryResult<SearchWordsQuery, SearchWordsQueryVariables>;
export const GetSitesDocument = gql`
    query getSites($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    sites(filter: $filter, clusterid: $clusterid) {
      site
      title
      usersRate
      score
    }
  }
}
    `;

/**
 * __useGetSitesQuery__
 *
 * To run a query within a React component, call `useGetSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSitesQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useGetSitesQuery(baseOptions: Apollo.QueryHookOptions<GetSitesQuery, GetSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSitesQuery, GetSitesQueryVariables>(GetSitesDocument, options);
      }
export function useGetSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSitesQuery, GetSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSitesQuery, GetSitesQueryVariables>(GetSitesDocument, options);
        }
export type GetSitesQueryHookResult = ReturnType<typeof useGetSitesQuery>;
export type GetSitesLazyQueryHookResult = ReturnType<typeof useGetSitesLazyQuery>;
export type GetSitesQueryResult = Apollo.QueryResult<GetSitesQuery, GetSitesQueryVariables>;
export const AmazonItemsDocument = gql`
    query amazonItems($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    items(filter: $filter, clusterid: $clusterid)
  }
}
    `;

/**
 * __useAmazonItemsQuery__
 *
 * To run a query within a React component, call `useAmazonItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmazonItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmazonItemsQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useAmazonItemsQuery(baseOptions: Apollo.QueryHookOptions<AmazonItemsQuery, AmazonItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmazonItemsQuery, AmazonItemsQueryVariables>(AmazonItemsDocument, options);
      }
export function useAmazonItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmazonItemsQuery, AmazonItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmazonItemsQuery, AmazonItemsQueryVariables>(AmazonItemsDocument, options);
        }
export type AmazonItemsQueryHookResult = ReturnType<typeof useAmazonItemsQuery>;
export type AmazonItemsLazyQueryHookResult = ReturnType<typeof useAmazonItemsLazyQuery>;
export type AmazonItemsQueryResult = Apollo.QueryResult<AmazonItemsQuery, AmazonItemsQueryVariables>;
export const GetAppsDocument = gql`
    query getApps($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    apps(filter: $filter, clusterid: $clusterid) {
      app
      title
      usersRate
      score
    }
  }
}
    `;

/**
 * __useGetAppsQuery__
 *
 * To run a query within a React component, call `useGetAppsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppsQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useGetAppsQuery(baseOptions: Apollo.QueryHookOptions<GetAppsQuery, GetAppsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppsQuery, GetAppsQueryVariables>(GetAppsDocument, options);
      }
export function useGetAppsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppsQuery, GetAppsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppsQuery, GetAppsQueryVariables>(GetAppsDocument, options);
        }
export type GetAppsQueryHookResult = ReturnType<typeof useGetAppsQuery>;
export type GetAppsLazyQueryHookResult = ReturnType<typeof useGetAppsLazyQuery>;
export type GetAppsQueryResult = Apollo.QueryResult<GetAppsQuery, GetAppsQueryVariables>;
export const GenderAgeBracketsDocument = gql`
    query genderAgeBrackets($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    genderAgeBrackets(filter: $filter, clusterid: $clusterid) {
      type
      gender
      ageBracket
      usersRate
    }
  }
}
    `;

/**
 * __useGenderAgeBracketsQuery__
 *
 * To run a query within a React component, call `useGenderAgeBracketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenderAgeBracketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenderAgeBracketsQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useGenderAgeBracketsQuery(baseOptions: Apollo.QueryHookOptions<GenderAgeBracketsQuery, GenderAgeBracketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenderAgeBracketsQuery, GenderAgeBracketsQueryVariables>(GenderAgeBracketsDocument, options);
      }
export function useGenderAgeBracketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenderAgeBracketsQuery, GenderAgeBracketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenderAgeBracketsQuery, GenderAgeBracketsQueryVariables>(GenderAgeBracketsDocument, options);
        }
export type GenderAgeBracketsQueryHookResult = ReturnType<typeof useGenderAgeBracketsQuery>;
export type GenderAgeBracketsLazyQueryHookResult = ReturnType<typeof useGenderAgeBracketsLazyQuery>;
export type GenderAgeBracketsQueryResult = Apollo.QueryResult<GenderAgeBracketsQuery, GenderAgeBracketsQueryVariables>;
export const JobsDocument = gql`
    query jobs($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    jobs(filter: $filter, clusterid: $clusterid) {
      type
      job
      usersRate
    }
  }
}
    `;

/**
 * __useJobsQuery__
 *
 * To run a query within a React component, call `useJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobsQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useJobsQuery(baseOptions: Apollo.QueryHookOptions<JobsQuery, JobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobsQuery, JobsQueryVariables>(JobsDocument, options);
      }
export function useJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobsQuery, JobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobsQuery, JobsQueryVariables>(JobsDocument, options);
        }
export type JobsQueryHookResult = ReturnType<typeof useJobsQuery>;
export type JobsLazyQueryHookResult = ReturnType<typeof useJobsLazyQuery>;
export type JobsQueryResult = Apollo.QueryResult<JobsQuery, JobsQueryVariables>;
export const MarriageDataDocument = gql`
    query marriageData($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    marriageData(filter: $filter, clusterid: $clusterid) {
      type
      marriage
      usersRate
    }
  }
}
    `;

/**
 * __useMarriageDataQuery__
 *
 * To run a query within a React component, call `useMarriageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarriageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarriageDataQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useMarriageDataQuery(baseOptions: Apollo.QueryHookOptions<MarriageDataQuery, MarriageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarriageDataQuery, MarriageDataQueryVariables>(MarriageDataDocument, options);
      }
export function useMarriageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarriageDataQuery, MarriageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarriageDataQuery, MarriageDataQueryVariables>(MarriageDataDocument, options);
        }
export type MarriageDataQueryHookResult = ReturnType<typeof useMarriageDataQuery>;
export type MarriageDataLazyQueryHookResult = ReturnType<typeof useMarriageDataLazyQuery>;
export type MarriageDataQueryResult = Apollo.QueryResult<MarriageDataQuery, MarriageDataQueryVariables>;
export const ChildDataDocument = gql`
    query childData($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    childData(filter: $filter, clusterid: $clusterid) {
      type
      child
      usersRate
    }
  }
}
    `;

/**
 * __useChildDataQuery__
 *
 * To run a query within a React component, call `useChildDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChildDataQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useChildDataQuery(baseOptions: Apollo.QueryHookOptions<ChildDataQuery, ChildDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChildDataQuery, ChildDataQueryVariables>(ChildDataDocument, options);
      }
export function useChildDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChildDataQuery, ChildDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChildDataQuery, ChildDataQueryVariables>(ChildDataDocument, options);
        }
export type ChildDataQueryHookResult = ReturnType<typeof useChildDataQuery>;
export type ChildDataLazyQueryHookResult = ReturnType<typeof useChildDataLazyQuery>;
export type ChildDataQueryResult = Apollo.QueryResult<ChildDataQuery, ChildDataQueryVariables>;
export const LivingAreaDataDocument = gql`
    query livingAreaData($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    livingAreaData(filter: $filter, clusterid: $clusterid) {
      type
      livingArea
      usersRate
    }
  }
}
    `;

/**
 * __useLivingAreaDataQuery__
 *
 * To run a query within a React component, call `useLivingAreaDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useLivingAreaDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLivingAreaDataQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useLivingAreaDataQuery(baseOptions: Apollo.QueryHookOptions<LivingAreaDataQuery, LivingAreaDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LivingAreaDataQuery, LivingAreaDataQueryVariables>(LivingAreaDataDocument, options);
      }
export function useLivingAreaDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LivingAreaDataQuery, LivingAreaDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LivingAreaDataQuery, LivingAreaDataQueryVariables>(LivingAreaDataDocument, options);
        }
export type LivingAreaDataQueryHookResult = ReturnType<typeof useLivingAreaDataQuery>;
export type LivingAreaDataLazyQueryHookResult = ReturnType<typeof useLivingAreaDataLazyQuery>;
export type LivingAreaDataQueryResult = Apollo.QueryResult<LivingAreaDataQuery, LivingAreaDataQueryVariables>;
export const HomeIncomeDataDocument = gql`
    query homeIncomeData($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    homeIncomeData(filter: $filter, clusterid: $clusterid) {
      type
      homeIncome
      usersRate
    }
  }
}
    `;

/**
 * __useHomeIncomeDataQuery__
 *
 * To run a query within a React component, call `useHomeIncomeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeIncomeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeIncomeDataQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useHomeIncomeDataQuery(baseOptions: Apollo.QueryHookOptions<HomeIncomeDataQuery, HomeIncomeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeIncomeDataQuery, HomeIncomeDataQueryVariables>(HomeIncomeDataDocument, options);
      }
export function useHomeIncomeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeIncomeDataQuery, HomeIncomeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeIncomeDataQuery, HomeIncomeDataQueryVariables>(HomeIncomeDataDocument, options);
        }
export type HomeIncomeDataQueryHookResult = ReturnType<typeof useHomeIncomeDataQuery>;
export type HomeIncomeDataLazyQueryHookResult = ReturnType<typeof useHomeIncomeDataLazyQuery>;
export type HomeIncomeDataQueryResult = Apollo.QueryResult<HomeIncomeDataQuery, HomeIncomeDataQueryVariables>;
export const FamilyDataDocument = gql`
    query familyData($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    familyData(filter: $filter, clusterid: $clusterid) {
      validState
      target {
        value
        usersRate
      }
      monitor {
        value
        usersRate
      }
    }
  }
}
    `;

/**
 * __useFamilyDataQuery__
 *
 * To run a query within a React component, call `useFamilyDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFamilyDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFamilyDataQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useFamilyDataQuery(baseOptions: Apollo.QueryHookOptions<FamilyDataQuery, FamilyDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FamilyDataQuery, FamilyDataQueryVariables>(FamilyDataDocument, options);
      }
export function useFamilyDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FamilyDataQuery, FamilyDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FamilyDataQuery, FamilyDataQueryVariables>(FamilyDataDocument, options);
        }
export type FamilyDataQueryHookResult = ReturnType<typeof useFamilyDataQuery>;
export type FamilyDataLazyQueryHookResult = ReturnType<typeof useFamilyDataLazyQuery>;
export type FamilyDataQueryResult = Apollo.QueryResult<FamilyDataQuery, FamilyDataQueryVariables>;
export const LivingStyleDataDocument = gql`
    query livingStyleData($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    livingStyleData(filter: $filter, clusterid: $clusterid) {
      validState
      target {
        value
        usersRate
      }
      monitor {
        value
        usersRate
      }
    }
  }
}
    `;

/**
 * __useLivingStyleDataQuery__
 *
 * To run a query within a React component, call `useLivingStyleDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useLivingStyleDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLivingStyleDataQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useLivingStyleDataQuery(baseOptions: Apollo.QueryHookOptions<LivingStyleDataQuery, LivingStyleDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LivingStyleDataQuery, LivingStyleDataQueryVariables>(LivingStyleDataDocument, options);
      }
export function useLivingStyleDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LivingStyleDataQuery, LivingStyleDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LivingStyleDataQuery, LivingStyleDataQueryVariables>(LivingStyleDataDocument, options);
        }
export type LivingStyleDataQueryHookResult = ReturnType<typeof useLivingStyleDataQuery>;
export type LivingStyleDataLazyQueryHookResult = ReturnType<typeof useLivingStyleDataLazyQuery>;
export type LivingStyleDataQueryResult = Apollo.QueryResult<LivingStyleDataQuery, LivingStyleDataQueryVariables>;
export const MediaContactDocument = gql`
    query mediaContact($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    tvData: mediaContact(media: "tv", filter: $filter, clusterid: $clusterid) {
      validState
      monitor {
        value
        usersRate
      }
      target {
        value
        usersRate
      }
    }
    vodData: mediaContact(media: "vod", filter: $filter, clusterid: $clusterid) {
      validState
      monitor {
        value
        usersRate
      }
      target {
        value
        usersRate
      }
    }
    newspaperData: mediaContact(
      media: "newspaper"
      filter: $filter
      clusterid: $clusterid
    ) {
      validState
      monitor {
        value
        usersRate
      }
      target {
        value
        usersRate
      }
    }
    magazineData: mediaContact(
      media: "magazine"
      filter: $filter
      clusterid: $clusterid
    ) {
      validState
      monitor {
        value
        usersRate
      }
      target {
        value
        usersRate
      }
    }
    ebookData: mediaContact(media: "ebook", filter: $filter, clusterid: $clusterid) {
      validState
      monitor {
        value
        usersRate
      }
      target {
        value
        usersRate
      }
    }
    radioData: mediaContact(media: "radio", filter: $filter, clusterid: $clusterid) {
      validState
      monitor {
        value
        usersRate
      }
      target {
        value
        usersRate
      }
    }
  }
}
    `;

/**
 * __useMediaContactQuery__
 *
 * To run a query within a React component, call `useMediaContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaContactQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useMediaContactQuery(baseOptions: Apollo.QueryHookOptions<MediaContactQuery, MediaContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaContactQuery, MediaContactQueryVariables>(MediaContactDocument, options);
      }
export function useMediaContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaContactQuery, MediaContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaContactQuery, MediaContactQueryVariables>(MediaContactDocument, options);
        }
export type MediaContactQueryHookResult = ReturnType<typeof useMediaContactQuery>;
export type MediaContactLazyQueryHookResult = ReturnType<typeof useMediaContactLazyQuery>;
export type MediaContactQueryResult = Apollo.QueryResult<MediaContactQuery, MediaContactQueryVariables>;
export const AppUsageDocument = gql`
    query appUsage($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    lineData: appUsage(app: "line", filter: $filter, clusterid: $clusterid) {
      validState
      monitor {
        value
        usersRate
      }
      target {
        value
        usersRate
      }
    }
    twitterData: appUsage(app: "twitter", filter: $filter, clusterid: $clusterid) {
      validState
      monitor {
        value
        usersRate
      }
      target {
        value
        usersRate
      }
    }
    facebookData: appUsage(app: "facebook", filter: $filter, clusterid: $clusterid) {
      validState
      monitor {
        value
        usersRate
      }
      target {
        value
        usersRate
      }
    }
    instagramData: appUsage(
      app: "instagram"
      filter: $filter
      clusterid: $clusterid
    ) {
      validState
      monitor {
        value
        usersRate
      }
      target {
        value
        usersRate
      }
    }
    yahooData: appUsage(app: "yahoo", filter: $filter, clusterid: $clusterid) {
      validState
      monitor {
        value
        usersRate
      }
      target {
        value
        usersRate
      }
    }
    newsData: appUsage(app: "news", filter: $filter, clusterid: $clusterid) {
      validState
      monitor {
        value
        usersRate
      }
      target {
        value
        usersRate
      }
    }
    gameData: appUsage(app: "game", filter: $filter, clusterid: $clusterid) {
      validState
      monitor {
        value
        usersRate
      }
      target {
        value
        usersRate
      }
    }
    videoData: appUsage(app: "video", filter: $filter, clusterid: $clusterid) {
      validState
      monitor {
        value
        usersRate
      }
      target {
        value
        usersRate
      }
    }
  }
}
    `;

/**
 * __useAppUsageQuery__
 *
 * To run a query within a React component, call `useAppUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppUsageQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useAppUsageQuery(baseOptions: Apollo.QueryHookOptions<AppUsageQuery, AppUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppUsageQuery, AppUsageQueryVariables>(AppUsageDocument, options);
      }
export function useAppUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppUsageQuery, AppUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppUsageQuery, AppUsageQueryVariables>(AppUsageDocument, options);
        }
export type AppUsageQueryHookResult = ReturnType<typeof useAppUsageQuery>;
export type AppUsageLazyQueryHookResult = ReturnType<typeof useAppUsageLazyQuery>;
export type AppUsageQueryResult = Apollo.QueryResult<AppUsageQuery, AppUsageQueryVariables>;
export const ShoppingDocument = gql`
    query shopping($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    channel: shopping(question: "channel", filter: $filter, clusterid: $clusterid) {
      validState
      monitor {
        value
        usersRate
      }
      target {
        value
        usersRate
      }
    }
    behavior: shopping(question: "behavior", filter: $filter, clusterid: $clusterid) {
      validState
      monitor {
        value
        usersRate
      }
      target {
        value
        usersRate
      }
    }
    measure: shopping(question: "measure", filter: $filter, clusterid: $clusterid) {
      validState
      monitor {
        value
        usersRate
      }
      target {
        value
        usersRate
      }
    }
    point: shopping(question: "point", filter: $filter, clusterid: $clusterid) {
      validState
      monitor {
        value
        usersRate
      }
      target {
        value
        usersRate
      }
    }
  }
}
    `;

/**
 * __useShoppingQuery__
 *
 * To run a query within a React component, call `useShoppingQuery` and pass it any options that fit your needs.
 * When your component renders, `useShoppingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShoppingQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useShoppingQuery(baseOptions: Apollo.QueryHookOptions<ShoppingQuery, ShoppingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShoppingQuery, ShoppingQueryVariables>(ShoppingDocument, options);
      }
export function useShoppingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShoppingQuery, ShoppingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShoppingQuery, ShoppingQueryVariables>(ShoppingDocument, options);
        }
export type ShoppingQueryHookResult = ReturnType<typeof useShoppingQuery>;
export type ShoppingLazyQueryHookResult = ReturnType<typeof useShoppingLazyQuery>;
export type ShoppingQueryResult = Apollo.QueryResult<ShoppingQuery, ShoppingQueryVariables>;
export const AssetsDocument = gql`
    query assets($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    disposableIncome(filter: $filter, clusterid: $clusterid) {
      validState
      monitor {
        value
        usersRate
      }
      target {
        value
        usersRate
      }
    }
    ownedAssets(filter: $filter, clusterid: $clusterid) {
      validState
      monitor {
        value
        usersRate
      }
      target {
        value
        usersRate
      }
    }
    spending(filter: $filter, clusterid: $clusterid) {
      validState
      monitor {
        spending
        amount
      }
      target {
        spending
        amount
      }
    }
  }
}
    `;

/**
 * __useAssetsQuery__
 *
 * To run a query within a React component, call `useAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetsQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useAssetsQuery(baseOptions: Apollo.QueryHookOptions<AssetsQuery, AssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetsQuery, AssetsQueryVariables>(AssetsDocument, options);
      }
export function useAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetsQuery, AssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetsQuery, AssetsQueryVariables>(AssetsDocument, options);
        }
export type AssetsQueryHookResult = ReturnType<typeof useAssetsQuery>;
export type AssetsLazyQueryHookResult = ReturnType<typeof useAssetsLazyQuery>;
export type AssetsQueryResult = Apollo.QueryResult<AssetsQuery, AssetsQueryVariables>;
export const InterestDocument = gql`
    query interest($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    interest(filter: $filter, clusterid: $clusterid) {
      validState
      interests {
        interest
        usersRate
        score
      }
    }
  }
}
    `;

/**
 * __useInterestQuery__
 *
 * To run a query within a React component, call `useInterestQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterestQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useInterestQuery(baseOptions: Apollo.QueryHookOptions<InterestQuery, InterestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterestQuery, InterestQueryVariables>(InterestDocument, options);
      }
export function useInterestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterestQuery, InterestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterestQuery, InterestQueryVariables>(InterestDocument, options);
        }
export type InterestQueryHookResult = ReturnType<typeof useInterestQuery>;
export type InterestLazyQueryHookResult = ReturnType<typeof useInterestLazyQuery>;
export type InterestQueryResult = Apollo.QueryResult<InterestQuery, InterestQueryVariables>;
export const BodyTroubleDocument = gql`
    query bodyTrouble($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    bodyCare: bodyTrouble(
      troubleType: "care"
      filter: $filter
      clusterid: $clusterid
    ) {
      validState
      data {
        bodyTrouble
        usersRate
        score
      }
    }
    bodyMeasure: bodyTrouble(
      troubleType: "measure"
      filter: $filter
      clusterid: $clusterid
    ) {
      validState
      data {
        bodyTrouble
        usersRate
        score
      }
    }
  }
}
    `;

/**
 * __useBodyTroubleQuery__
 *
 * To run a query within a React component, call `useBodyTroubleQuery` and pass it any options that fit your needs.
 * When your component renders, `useBodyTroubleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBodyTroubleQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useBodyTroubleQuery(baseOptions: Apollo.QueryHookOptions<BodyTroubleQuery, BodyTroubleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BodyTroubleQuery, BodyTroubleQueryVariables>(BodyTroubleDocument, options);
      }
export function useBodyTroubleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BodyTroubleQuery, BodyTroubleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BodyTroubleQuery, BodyTroubleQueryVariables>(BodyTroubleDocument, options);
        }
export type BodyTroubleQueryHookResult = ReturnType<typeof useBodyTroubleQuery>;
export type BodyTroubleLazyQueryHookResult = ReturnType<typeof useBodyTroubleLazyQuery>;
export type BodyTroubleQueryResult = Apollo.QueryResult<BodyTroubleQuery, BodyTroubleQueryVariables>;
export const SportsDocument = gql`
    query sports($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    sportsWatch: sports(
      watchOrPlay: "watch"
      filter: $filter
      clusterid: $clusterid
    ) {
      validState
      data {
        sports
        usersRate
        score
      }
    }
    sportsPlay: sports(watchOrPlay: "play", filter: $filter, clusterid: $clusterid) {
      validState
      data {
        sports
        usersRate
        score
      }
    }
  }
}
    `;

/**
 * __useSportsQuery__
 *
 * To run a query within a React component, call `useSportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSportsQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useSportsQuery(baseOptions: Apollo.QueryHookOptions<SportsQuery, SportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SportsQuery, SportsQueryVariables>(SportsDocument, options);
      }
export function useSportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SportsQuery, SportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SportsQuery, SportsQueryVariables>(SportsDocument, options);
        }
export type SportsQueryHookResult = ReturnType<typeof useSportsQuery>;
export type SportsLazyQueryHookResult = ReturnType<typeof useSportsLazyQuery>;
export type SportsQueryResult = Apollo.QueryResult<SportsQuery, SportsQueryVariables>;
export const SiteRankingDocument = gql`
    query siteRanking($extractid: Int!, $siteCategories: [String!], $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    sites(
      limit: 100
      siteCategories: $siteCategories
      filter: $filter
      clusterid: $clusterid
    ) {
      site
      title
      siteCategory
      usersRate
      score
    }
  }
}
    `;

/**
 * __useSiteRankingQuery__
 *
 * To run a query within a React component, call `useSiteRankingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteRankingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteRankingQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      siteCategories: // value for 'siteCategories'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useSiteRankingQuery(baseOptions: Apollo.QueryHookOptions<SiteRankingQuery, SiteRankingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteRankingQuery, SiteRankingQueryVariables>(SiteRankingDocument, options);
      }
export function useSiteRankingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteRankingQuery, SiteRankingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteRankingQuery, SiteRankingQueryVariables>(SiteRankingDocument, options);
        }
export type SiteRankingQueryHookResult = ReturnType<typeof useSiteRankingQuery>;
export type SiteRankingLazyQueryHookResult = ReturnType<typeof useSiteRankingLazyQuery>;
export type SiteRankingQueryResult = Apollo.QueryResult<SiteRankingQuery, SiteRankingQueryVariables>;
export const AppRankingDocument = gql`
    query appRanking($extractid: Int!, $appCategories: [String!], $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    apps(
      limit: 100
      appCategories: $appCategories
      filter: $filter
      clusterid: $clusterid
    ) {
      app
      title
      category
      usersRate
      score
    }
  }
}
    `;

/**
 * __useAppRankingQuery__
 *
 * To run a query within a React component, call `useAppRankingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppRankingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppRankingQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      appCategories: // value for 'appCategories'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useAppRankingQuery(baseOptions: Apollo.QueryHookOptions<AppRankingQuery, AppRankingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppRankingQuery, AppRankingQueryVariables>(AppRankingDocument, options);
      }
export function useAppRankingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppRankingQuery, AppRankingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppRankingQuery, AppRankingQueryVariables>(AppRankingDocument, options);
        }
export type AppRankingQueryHookResult = ReturnType<typeof useAppRankingQuery>;
export type AppRankingLazyQueryHookResult = ReturnType<typeof useAppRankingLazyQuery>;
export type AppRankingQueryResult = Apollo.QueryResult<AppRankingQuery, AppRankingQueryVariables>;
export const WordRankingDocument = gql`
    query wordRanking($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    words(limit: 100, filter: $filter, clusterid: $clusterid) {
      word
      usersRate
      femaleRate
      age
      score
    }
  }
}
    `;

/**
 * __useWordRankingQuery__
 *
 * To run a query within a React component, call `useWordRankingQuery` and pass it any options that fit your needs.
 * When your component renders, `useWordRankingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWordRankingQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useWordRankingQuery(baseOptions: Apollo.QueryHookOptions<WordRankingQuery, WordRankingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WordRankingQuery, WordRankingQueryVariables>(WordRankingDocument, options);
      }
export function useWordRankingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WordRankingQuery, WordRankingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WordRankingQuery, WordRankingQueryVariables>(WordRankingDocument, options);
        }
export type WordRankingQueryHookResult = ReturnType<typeof useWordRankingQuery>;
export type WordRankingLazyQueryHookResult = ReturnType<typeof useWordRankingLazyQuery>;
export type WordRankingQueryResult = Apollo.QueryResult<WordRankingQuery, WordRankingQueryVariables>;
export const UserListDocument = gql`
    query userList($extractid: Int!, $limit: Int!, $offset: Int!, $liked: Boolean, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    userList(filter: $filter, clusterid: $clusterid, liked: $liked) {
      users(limit: $limit, offset: $offset) {
        extractuserid
        vid
        dbname
        gender
        ageBracket
        marriage
        child
        prefecture
        homeIncome
        job
        clusterid
        note
        blocks
        liked
        likes
      }
    }
  }
}
    `;

/**
 * __useUserListQuery__
 *
 * To run a query within a React component, call `useUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      liked: // value for 'liked'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useUserListQuery(baseOptions: Apollo.QueryHookOptions<UserListQuery, UserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
      }
export function useUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserListQuery, UserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
        }
export type UserListQueryHookResult = ReturnType<typeof useUserListQuery>;
export type UserListLazyQueryHookResult = ReturnType<typeof useUserListLazyQuery>;
export type UserListQueryResult = Apollo.QueryResult<UserListQuery, UserListQueryVariables>;
export const UserWordsDocument = gql`
    query userWords($extractid: Int!, $extractuserid: Int!, $siteCategory: [String!], $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    userList(filter: $filter, clusterid: $clusterid) {
      userWords(extractuserid: $extractuserid, siteCategory: $siteCategory) {
        word
        cnt
      }
    }
  }
}
    `;

/**
 * __useUserWordsQuery__
 *
 * To run a query within a React component, call `useUserWordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserWordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserWordsQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      extractuserid: // value for 'extractuserid'
 *      siteCategory: // value for 'siteCategory'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useUserWordsQuery(baseOptions: Apollo.QueryHookOptions<UserWordsQuery, UserWordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserWordsQuery, UserWordsQueryVariables>(UserWordsDocument, options);
      }
export function useUserWordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserWordsQuery, UserWordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserWordsQuery, UserWordsQueryVariables>(UserWordsDocument, options);
        }
export type UserWordsQueryHookResult = ReturnType<typeof useUserWordsQuery>;
export type UserWordsLazyQueryHookResult = ReturnType<typeof useUserWordsLazyQuery>;
export type UserWordsQueryResult = Apollo.QueryResult<UserWordsQuery, UserWordsQueryVariables>;
export const UserSessionsDocument = gql`
    query userSessions($extractid: Int!, $extractuserid: Int!, $siteCategory: [String!], $appCategory: [String!], $offset: Int!, $limit: Int!, $filter: ExtractFilter, $clusterid: Int, $withApp: Boolean, $withItem: Boolean) {
  extract(extractid: $extractid) {
    userList(filter: $filter, clusterid: $clusterid) {
      sessions(
        extractuserid: $extractuserid
        offset: $offset
        limit: $limit
        siteCategory: $siteCategory
        appCategory: $appCategory
        withApp: $withApp
        withItem: $withItem
      ) {
        row
        type
        extractuserid
        extractsessionid
        blockid
        base
        accessTime
        site
        url
        title
        pv
        timeOn
        refCatName
        refKeyword
        refUrl
        filter
        comment
      }
    }
  }
}
    `;

/**
 * __useUserSessionsQuery__
 *
 * To run a query within a React component, call `useUserSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSessionsQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      extractuserid: // value for 'extractuserid'
 *      siteCategory: // value for 'siteCategory'
 *      appCategory: // value for 'appCategory'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *      withApp: // value for 'withApp'
 *      withItem: // value for 'withItem'
 *   },
 * });
 */
export function useUserSessionsQuery(baseOptions: Apollo.QueryHookOptions<UserSessionsQuery, UserSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSessionsQuery, UserSessionsQueryVariables>(UserSessionsDocument, options);
      }
export function useUserSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSessionsQuery, UserSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSessionsQuery, UserSessionsQueryVariables>(UserSessionsDocument, options);
        }
export type UserSessionsQueryHookResult = ReturnType<typeof useUserSessionsQuery>;
export type UserSessionsLazyQueryHookResult = ReturnType<typeof useUserSessionsLazyQuery>;
export type UserSessionsQueryResult = Apollo.QueryResult<UserSessionsQuery, UserSessionsQueryVariables>;
export const UserSiteCategoriesDocument = gql`
    query userSiteCategories($extractid: Int!, $extractuserid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    userList(filter: $filter, clusterid: $clusterid) {
      siteCategories(extractuserid: $extractuserid)
    }
  }
}
    `;

/**
 * __useUserSiteCategoriesQuery__
 *
 * To run a query within a React component, call `useUserSiteCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSiteCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSiteCategoriesQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      extractuserid: // value for 'extractuserid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useUserSiteCategoriesQuery(baseOptions: Apollo.QueryHookOptions<UserSiteCategoriesQuery, UserSiteCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSiteCategoriesQuery, UserSiteCategoriesQueryVariables>(UserSiteCategoriesDocument, options);
      }
export function useUserSiteCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSiteCategoriesQuery, UserSiteCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSiteCategoriesQuery, UserSiteCategoriesQueryVariables>(UserSiteCategoriesDocument, options);
        }
export type UserSiteCategoriesQueryHookResult = ReturnType<typeof useUserSiteCategoriesQuery>;
export type UserSiteCategoriesLazyQueryHookResult = ReturnType<typeof useUserSiteCategoriesLazyQuery>;
export type UserSiteCategoriesQueryResult = Apollo.QueryResult<UserSiteCategoriesQuery, UserSiteCategoriesQueryVariables>;
export const UserAppCategoriesDocument = gql`
    query userAppCategories($extractid: Int!, $extractuserid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    userList(filter: $filter, clusterid: $clusterid) {
      appCategories(extractuserid: $extractuserid)
    }
  }
}
    `;

/**
 * __useUserAppCategoriesQuery__
 *
 * To run a query within a React component, call `useUserAppCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAppCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAppCategoriesQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      extractuserid: // value for 'extractuserid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useUserAppCategoriesQuery(baseOptions: Apollo.QueryHookOptions<UserAppCategoriesQuery, UserAppCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAppCategoriesQuery, UserAppCategoriesQueryVariables>(UserAppCategoriesDocument, options);
      }
export function useUserAppCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAppCategoriesQuery, UserAppCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAppCategoriesQuery, UserAppCategoriesQueryVariables>(UserAppCategoriesDocument, options);
        }
export type UserAppCategoriesQueryHookResult = ReturnType<typeof useUserAppCategoriesQuery>;
export type UserAppCategoriesLazyQueryHookResult = ReturnType<typeof useUserAppCategoriesLazyQuery>;
export type UserAppCategoriesQueryResult = Apollo.QueryResult<UserAppCategoriesQuery, UserAppCategoriesQueryVariables>;
export const NoteDocument = gql`
    query note($extractid: Int!, $extractuserid: Int!) {
  extract(extractid: $extractid) {
    userList {
      note(extractuserid: $extractuserid)
    }
  }
}
    `;

/**
 * __useNoteQuery__
 *
 * To run a query within a React component, call `useNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoteQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      extractuserid: // value for 'extractuserid'
 *   },
 * });
 */
export function useNoteQuery(baseOptions: Apollo.QueryHookOptions<NoteQuery, NoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NoteQuery, NoteQueryVariables>(NoteDocument, options);
      }
export function useNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NoteQuery, NoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NoteQuery, NoteQueryVariables>(NoteDocument, options);
        }
export type NoteQueryHookResult = ReturnType<typeof useNoteQuery>;
export type NoteLazyQueryHookResult = ReturnType<typeof useNoteLazyQuery>;
export type NoteQueryResult = Apollo.QueryResult<NoteQuery, NoteQueryVariables>;
export const UpdateNoteDocument = gql`
    mutation updateNote($extractid: Int!, $extractuserid: Int!, $note: String!) {
  updateNote(extractid: $extractid, extractuserid: $extractuserid, note: $note)
}
    `;
export type UpdateNoteMutationFn = Apollo.MutationFunction<UpdateNoteMutation, UpdateNoteMutationVariables>;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      extractuserid: // value for 'extractuserid'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteMutation, UpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument, options);
      }
export type UpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteMutation>;
export type UpdateNoteMutationResult = Apollo.MutationResult<UpdateNoteMutation>;
export type UpdateNoteMutationOptions = Apollo.BaseMutationOptions<UpdateNoteMutation, UpdateNoteMutationVariables>;
export const UpdateCommentDocument = gql`
    mutation updateComment($extractid: Int!, $extractuserid: Int!, $extractsessionid: Int!, $comment: String) {
  updateComment(
    extractid: $extractid
    extractuserid: $extractuserid
    extractsessionid: $extractsessionid
    comment: $comment
  )
}
    `;
export type UpdateCommentMutationFn = Apollo.MutationFunction<UpdateCommentMutation, UpdateCommentMutationVariables>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      extractuserid: // value for 'extractuserid'
 *      extractsessionid: // value for 'extractsessionid'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentMutation, UpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const UpdateLikedDocument = gql`
    mutation updateLiked($extractid: Int!, $extractuserid: Int!, $liked: Boolean!) {
  updateLiked(extractid: $extractid, extractuserid: $extractuserid, liked: $liked)
}
    `;
export type UpdateLikedMutationFn = Apollo.MutationFunction<UpdateLikedMutation, UpdateLikedMutationVariables>;

/**
 * __useUpdateLikedMutation__
 *
 * To run a mutation, you first call `useUpdateLikedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLikedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLikedMutation, { data, loading, error }] = useUpdateLikedMutation({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      extractuserid: // value for 'extractuserid'
 *      liked: // value for 'liked'
 *   },
 * });
 */
export function useUpdateLikedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLikedMutation, UpdateLikedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLikedMutation, UpdateLikedMutationVariables>(UpdateLikedDocument, options);
      }
export type UpdateLikedMutationHookResult = ReturnType<typeof useUpdateLikedMutation>;
export type UpdateLikedMutationResult = Apollo.MutationResult<UpdateLikedMutation>;
export type UpdateLikedMutationOptions = Apollo.BaseMutationOptions<UpdateLikedMutation, UpdateLikedMutationVariables>;
export const ExecuteClusterDocument = gql`
    mutation executeCluster($extractid: Int!, $clusterNum: Int!, $userids: [Int!]) {
  executeCluster(
    extractid: $extractid
    clusterNum: $clusterNum
    userids: $userids
  )
}
    `;
export type ExecuteClusterMutationFn = Apollo.MutationFunction<ExecuteClusterMutation, ExecuteClusterMutationVariables>;

/**
 * __useExecuteClusterMutation__
 *
 * To run a mutation, you first call `useExecuteClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeClusterMutation, { data, loading, error }] = useExecuteClusterMutation({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      clusterNum: // value for 'clusterNum'
 *      userids: // value for 'userids'
 *   },
 * });
 */
export function useExecuteClusterMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteClusterMutation, ExecuteClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteClusterMutation, ExecuteClusterMutationVariables>(ExecuteClusterDocument, options);
      }
export type ExecuteClusterMutationHookResult = ReturnType<typeof useExecuteClusterMutation>;
export type ExecuteClusterMutationResult = Apollo.MutationResult<ExecuteClusterMutation>;
export type ExecuteClusterMutationOptions = Apollo.BaseMutationOptions<ExecuteClusterMutation, ExecuteClusterMutationVariables>;
export const ClusterStateDocument = gql`
    query clusterState($extractid: Int!) {
  extract(extractid: $extractid) {
    cluster {
      state
    }
  }
}
    `;

/**
 * __useClusterStateQuery__
 *
 * To run a query within a React component, call `useClusterStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterStateQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *   },
 * });
 */
export function useClusterStateQuery(baseOptions: Apollo.QueryHookOptions<ClusterStateQuery, ClusterStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClusterStateQuery, ClusterStateQueryVariables>(ClusterStateDocument, options);
      }
export function useClusterStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClusterStateQuery, ClusterStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClusterStateQuery, ClusterStateQueryVariables>(ClusterStateDocument, options);
        }
export type ClusterStateQueryHookResult = ReturnType<typeof useClusterStateQuery>;
export type ClusterStateLazyQueryHookResult = ReturnType<typeof useClusterStateLazyQuery>;
export type ClusterStateQueryResult = Apollo.QueryResult<ClusterStateQuery, ClusterStateQueryVariables>;
export const ClustersDocument = gql`
    query clusters($extractid: Int!) {
  extract(extractid: $extractid) {
    cluster {
      clusters {
        clusterid
        name
        users
      }
    }
  }
}
    `;

/**
 * __useClustersQuery__
 *
 * To run a query within a React component, call `useClustersQuery` and pass it any options that fit your needs.
 * When your component renders, `useClustersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClustersQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *   },
 * });
 */
export function useClustersQuery(baseOptions: Apollo.QueryHookOptions<ClustersQuery, ClustersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClustersQuery, ClustersQueryVariables>(ClustersDocument, options);
      }
export function useClustersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClustersQuery, ClustersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClustersQuery, ClustersQueryVariables>(ClustersDocument, options);
        }
export type ClustersQueryHookResult = ReturnType<typeof useClustersQuery>;
export type ClustersLazyQueryHookResult = ReturnType<typeof useClustersLazyQuery>;
export type ClustersQueryResult = Apollo.QueryResult<ClustersQuery, ClustersQueryVariables>;
export const ClusterWordsDocument = gql`
    query clusterWords($extractid: Int!) {
  extract(extractid: $extractid) {
    cluster {
      clusters {
        clusterid
        name
        users
        words {
          word
          score
        }
      }
    }
  }
}
    `;

/**
 * __useClusterWordsQuery__
 *
 * To run a query within a React component, call `useClusterWordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterWordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterWordsQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *   },
 * });
 */
export function useClusterWordsQuery(baseOptions: Apollo.QueryHookOptions<ClusterWordsQuery, ClusterWordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClusterWordsQuery, ClusterWordsQueryVariables>(ClusterWordsDocument, options);
      }
export function useClusterWordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClusterWordsQuery, ClusterWordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClusterWordsQuery, ClusterWordsQueryVariables>(ClusterWordsDocument, options);
        }
export type ClusterWordsQueryHookResult = ReturnType<typeof useClusterWordsQuery>;
export type ClusterWordsLazyQueryHookResult = ReturnType<typeof useClusterWordsLazyQuery>;
export type ClusterWordsQueryResult = Apollo.QueryResult<ClusterWordsQuery, ClusterWordsQueryVariables>;
export const ClusterSitesDocument = gql`
    query clusterSites($extractid: Int!) {
  extract(extractid: $extractid) {
    cluster {
      clusters {
        clusterid
        name
        users
        sites {
          site
          title
          score
        }
      }
    }
  }
}
    `;

/**
 * __useClusterSitesQuery__
 *
 * To run a query within a React component, call `useClusterSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterSitesQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *   },
 * });
 */
export function useClusterSitesQuery(baseOptions: Apollo.QueryHookOptions<ClusterSitesQuery, ClusterSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClusterSitesQuery, ClusterSitesQueryVariables>(ClusterSitesDocument, options);
      }
export function useClusterSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClusterSitesQuery, ClusterSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClusterSitesQuery, ClusterSitesQueryVariables>(ClusterSitesDocument, options);
        }
export type ClusterSitesQueryHookResult = ReturnType<typeof useClusterSitesQuery>;
export type ClusterSitesLazyQueryHookResult = ReturnType<typeof useClusterSitesLazyQuery>;
export type ClusterSitesQueryResult = Apollo.QueryResult<ClusterSitesQuery, ClusterSitesQueryVariables>;
export const StopwordsDocument = gql`
    query stopwords($extractid: Int!) {
  extract(extractid: $extractid) {
    cluster {
      stopwords
    }
  }
}
    `;

/**
 * __useStopwordsQuery__
 *
 * To run a query within a React component, call `useStopwordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStopwordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStopwordsQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *   },
 * });
 */
export function useStopwordsQuery(baseOptions: Apollo.QueryHookOptions<StopwordsQuery, StopwordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StopwordsQuery, StopwordsQueryVariables>(StopwordsDocument, options);
      }
export function useStopwordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StopwordsQuery, StopwordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StopwordsQuery, StopwordsQueryVariables>(StopwordsDocument, options);
        }
export type StopwordsQueryHookResult = ReturnType<typeof useStopwordsQuery>;
export type StopwordsLazyQueryHookResult = ReturnType<typeof useStopwordsLazyQuery>;
export type StopwordsQueryResult = Apollo.QueryResult<StopwordsQuery, StopwordsQueryVariables>;
export const UpdateStopwordsDocument = gql`
    mutation updateStopwords($extractid: Int!, $stopwords: [String!]!) {
  updateStopwords(extractid: $extractid, stopwords: $stopwords)
}
    `;
export type UpdateStopwordsMutationFn = Apollo.MutationFunction<UpdateStopwordsMutation, UpdateStopwordsMutationVariables>;

/**
 * __useUpdateStopwordsMutation__
 *
 * To run a mutation, you first call `useUpdateStopwordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStopwordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStopwordsMutation, { data, loading, error }] = useUpdateStopwordsMutation({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      stopwords: // value for 'stopwords'
 *   },
 * });
 */
export function useUpdateStopwordsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStopwordsMutation, UpdateStopwordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStopwordsMutation, UpdateStopwordsMutationVariables>(UpdateStopwordsDocument, options);
      }
export type UpdateStopwordsMutationHookResult = ReturnType<typeof useUpdateStopwordsMutation>;
export type UpdateStopwordsMutationResult = Apollo.MutationResult<UpdateStopwordsMutation>;
export type UpdateStopwordsMutationOptions = Apollo.BaseMutationOptions<UpdateStopwordsMutation, UpdateStopwordsMutationVariables>;
export const UpdateClusterNameDocument = gql`
    mutation updateClusterName($extractid: Int!, $clusterid: Int!, $name: String!) {
  updateClusterName(extractid: $extractid, clusterid: $clusterid, name: $name)
}
    `;
export type UpdateClusterNameMutationFn = Apollo.MutationFunction<UpdateClusterNameMutation, UpdateClusterNameMutationVariables>;

/**
 * __useUpdateClusterNameMutation__
 *
 * To run a mutation, you first call `useUpdateClusterNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClusterNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClusterNameMutation, { data, loading, error }] = useUpdateClusterNameMutation({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      clusterid: // value for 'clusterid'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateClusterNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClusterNameMutation, UpdateClusterNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClusterNameMutation, UpdateClusterNameMutationVariables>(UpdateClusterNameDocument, options);
      }
export type UpdateClusterNameMutationHookResult = ReturnType<typeof useUpdateClusterNameMutation>;
export type UpdateClusterNameMutationResult = Apollo.MutationResult<UpdateClusterNameMutation>;
export type UpdateClusterNameMutationOptions = Apollo.BaseMutationOptions<UpdateClusterNameMutation, UpdateClusterNameMutationVariables>;
export const ClusterAttributesDocument = gql`
    query clusterAttributes($extractid: Int!) {
  extract(extractid: $extractid) {
    clusterAttributes
    clusterDisposableIncome
    clusterOwnedAssets
  }
}
    `;

/**
 * __useClusterAttributesQuery__
 *
 * To run a query within a React component, call `useClusterAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterAttributesQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *   },
 * });
 */
export function useClusterAttributesQuery(baseOptions: Apollo.QueryHookOptions<ClusterAttributesQuery, ClusterAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClusterAttributesQuery, ClusterAttributesQueryVariables>(ClusterAttributesDocument, options);
      }
export function useClusterAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClusterAttributesQuery, ClusterAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClusterAttributesQuery, ClusterAttributesQueryVariables>(ClusterAttributesDocument, options);
        }
export type ClusterAttributesQueryHookResult = ReturnType<typeof useClusterAttributesQuery>;
export type ClusterAttributesLazyQueryHookResult = ReturnType<typeof useClusterAttributesLazyQuery>;
export type ClusterAttributesQueryResult = Apollo.QueryResult<ClusterAttributesQuery, ClusterAttributesQueryVariables>;
export const ClusterFamilyDocument = gql`
    query clusterFamily($extractid: Int!) {
  extract(extractid: $extractid) {
    clusterFamily
  }
}
    `;

/**
 * __useClusterFamilyQuery__
 *
 * To run a query within a React component, call `useClusterFamilyQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterFamilyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterFamilyQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *   },
 * });
 */
export function useClusterFamilyQuery(baseOptions: Apollo.QueryHookOptions<ClusterFamilyQuery, ClusterFamilyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClusterFamilyQuery, ClusterFamilyQueryVariables>(ClusterFamilyDocument, options);
      }
export function useClusterFamilyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClusterFamilyQuery, ClusterFamilyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClusterFamilyQuery, ClusterFamilyQueryVariables>(ClusterFamilyDocument, options);
        }
export type ClusterFamilyQueryHookResult = ReturnType<typeof useClusterFamilyQuery>;
export type ClusterFamilyLazyQueryHookResult = ReturnType<typeof useClusterFamilyLazyQuery>;
export type ClusterFamilyQueryResult = Apollo.QueryResult<ClusterFamilyQuery, ClusterFamilyQueryVariables>;
export const ClusterLivingStyleDocument = gql`
    query clusterLivingStyle($extractid: Int!) {
  extract(extractid: $extractid) {
    clusterLivingStyle
  }
}
    `;

/**
 * __useClusterLivingStyleQuery__
 *
 * To run a query within a React component, call `useClusterLivingStyleQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterLivingStyleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterLivingStyleQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *   },
 * });
 */
export function useClusterLivingStyleQuery(baseOptions: Apollo.QueryHookOptions<ClusterLivingStyleQuery, ClusterLivingStyleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClusterLivingStyleQuery, ClusterLivingStyleQueryVariables>(ClusterLivingStyleDocument, options);
      }
export function useClusterLivingStyleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClusterLivingStyleQuery, ClusterLivingStyleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClusterLivingStyleQuery, ClusterLivingStyleQueryVariables>(ClusterLivingStyleDocument, options);
        }
export type ClusterLivingStyleQueryHookResult = ReturnType<typeof useClusterLivingStyleQuery>;
export type ClusterLivingStyleLazyQueryHookResult = ReturnType<typeof useClusterLivingStyleLazyQuery>;
export type ClusterLivingStyleQueryResult = Apollo.QueryResult<ClusterLivingStyleQuery, ClusterLivingStyleQueryVariables>;
export const ClusterMediaContactDocument = gql`
    query clusterMediaContact($extractid: Int!) {
  extract(extractid: $extractid) {
    clusterMediaContact
  }
}
    `;

/**
 * __useClusterMediaContactQuery__
 *
 * To run a query within a React component, call `useClusterMediaContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterMediaContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterMediaContactQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *   },
 * });
 */
export function useClusterMediaContactQuery(baseOptions: Apollo.QueryHookOptions<ClusterMediaContactQuery, ClusterMediaContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClusterMediaContactQuery, ClusterMediaContactQueryVariables>(ClusterMediaContactDocument, options);
      }
export function useClusterMediaContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClusterMediaContactQuery, ClusterMediaContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClusterMediaContactQuery, ClusterMediaContactQueryVariables>(ClusterMediaContactDocument, options);
        }
export type ClusterMediaContactQueryHookResult = ReturnType<typeof useClusterMediaContactQuery>;
export type ClusterMediaContactLazyQueryHookResult = ReturnType<typeof useClusterMediaContactLazyQuery>;
export type ClusterMediaContactQueryResult = Apollo.QueryResult<ClusterMediaContactQuery, ClusterMediaContactQueryVariables>;
export const ClusterAppUsageDocument = gql`
    query clusterAppUsage($extractid: Int!) {
  extract(extractid: $extractid) {
    clusterAppUsage
  }
}
    `;

/**
 * __useClusterAppUsageQuery__
 *
 * To run a query within a React component, call `useClusterAppUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterAppUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterAppUsageQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *   },
 * });
 */
export function useClusterAppUsageQuery(baseOptions: Apollo.QueryHookOptions<ClusterAppUsageQuery, ClusterAppUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClusterAppUsageQuery, ClusterAppUsageQueryVariables>(ClusterAppUsageDocument, options);
      }
export function useClusterAppUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClusterAppUsageQuery, ClusterAppUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClusterAppUsageQuery, ClusterAppUsageQueryVariables>(ClusterAppUsageDocument, options);
        }
export type ClusterAppUsageQueryHookResult = ReturnType<typeof useClusterAppUsageQuery>;
export type ClusterAppUsageLazyQueryHookResult = ReturnType<typeof useClusterAppUsageLazyQuery>;
export type ClusterAppUsageQueryResult = Apollo.QueryResult<ClusterAppUsageQuery, ClusterAppUsageQueryVariables>;
export const AttributesDocument = gql`
    query attributes($extractid: Int!, $filter: ExtractFilter, $clusterid: Int, $site: String, $word: String, $app: String) {
  extract(extractid: $extractid) {
    general {
      attributes(
        filter: $filter
        clusterid: $clusterid
        site: $site
        word: $word
        app: $app
      )
    }
  }
}
    `;

/**
 * __useAttributesQuery__
 *
 * To run a query within a React component, call `useAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributesQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *      site: // value for 'site'
 *      word: // value for 'word'
 *      app: // value for 'app'
 *   },
 * });
 */
export function useAttributesQuery(baseOptions: Apollo.QueryHookOptions<AttributesQuery, AttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributesQuery, AttributesQueryVariables>(AttributesDocument, options);
      }
export function useAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributesQuery, AttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributesQuery, AttributesQueryVariables>(AttributesDocument, options);
        }
export type AttributesQueryHookResult = ReturnType<typeof useAttributesQuery>;
export type AttributesLazyQueryHookResult = ReturnType<typeof useAttributesLazyQuery>;
export type AttributesQueryResult = Apollo.QueryResult<AttributesQuery, AttributesQueryVariables>;
export const GeneralTrendDocument = gql`
    query generalTrend($extractid: Int!, $filter: ExtractFilter, $clusterid: Int, $site: String, $word: String, $app: String) {
  extract(extractid: $extractid) {
    general {
      trend(
        dateGroup: WEEK
        filter: $filter
        clusterid: $clusterid
        site: $site
        word: $word
        app: $app
      )
    }
  }
}
    `;

/**
 * __useGeneralTrendQuery__
 *
 * To run a query within a React component, call `useGeneralTrendQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralTrendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralTrendQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *      site: // value for 'site'
 *      word: // value for 'word'
 *      app: // value for 'app'
 *   },
 * });
 */
export function useGeneralTrendQuery(baseOptions: Apollo.QueryHookOptions<GeneralTrendQuery, GeneralTrendQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneralTrendQuery, GeneralTrendQueryVariables>(GeneralTrendDocument, options);
      }
export function useGeneralTrendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneralTrendQuery, GeneralTrendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneralTrendQuery, GeneralTrendQueryVariables>(GeneralTrendDocument, options);
        }
export type GeneralTrendQueryHookResult = ReturnType<typeof useGeneralTrendQuery>;
export type GeneralTrendLazyQueryHookResult = ReturnType<typeof useGeneralTrendLazyQuery>;
export type GeneralTrendQueryResult = Apollo.QueryResult<GeneralTrendQuery, GeneralTrendQueryVariables>;
export const GeneralWordsDocument = gql`
    query generalWords($extractid: Int!, $filter: ExtractFilter, $clusterid: Int, $split: Boolean!, $site: String, $word: String, $befaft: Int) {
  extract(extractid: $extractid) {
    general {
      words(
        split: $split
        filter: $filter
        clusterid: $clusterid
        site: $site
        word: $word
        befaft: $befaft
      )
    }
  }
}
    `;

/**
 * __useGeneralWordsQuery__
 *
 * To run a query within a React component, call `useGeneralWordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralWordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralWordsQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *      split: // value for 'split'
 *      site: // value for 'site'
 *      word: // value for 'word'
 *      befaft: // value for 'befaft'
 *   },
 * });
 */
export function useGeneralWordsQuery(baseOptions: Apollo.QueryHookOptions<GeneralWordsQuery, GeneralWordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneralWordsQuery, GeneralWordsQueryVariables>(GeneralWordsDocument, options);
      }
export function useGeneralWordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneralWordsQuery, GeneralWordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneralWordsQuery, GeneralWordsQueryVariables>(GeneralWordsDocument, options);
        }
export type GeneralWordsQueryHookResult = ReturnType<typeof useGeneralWordsQuery>;
export type GeneralWordsLazyQueryHookResult = ReturnType<typeof useGeneralWordsLazyQuery>;
export type GeneralWordsQueryResult = Apollo.QueryResult<GeneralWordsQuery, GeneralWordsQueryVariables>;
export const GeneralSitesDocument = gql`
    query generalSites($extractid: Int!, $filter: ExtractFilter, $clusterid: Int, $site: String, $word: String, $befaft: Int) {
  extract(extractid: $extractid) {
    general {
      sites(
        filter: $filter
        clusterid: $clusterid
        site: $site
        word: $word
        befaft: $befaft
      )
    }
  }
}
    `;

/**
 * __useGeneralSitesQuery__
 *
 * To run a query within a React component, call `useGeneralSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralSitesQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *      site: // value for 'site'
 *      word: // value for 'word'
 *      befaft: // value for 'befaft'
 *   },
 * });
 */
export function useGeneralSitesQuery(baseOptions: Apollo.QueryHookOptions<GeneralSitesQuery, GeneralSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneralSitesQuery, GeneralSitesQueryVariables>(GeneralSitesDocument, options);
      }
export function useGeneralSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneralSitesQuery, GeneralSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneralSitesQuery, GeneralSitesQueryVariables>(GeneralSitesDocument, options);
        }
export type GeneralSitesQueryHookResult = ReturnType<typeof useGeneralSitesQuery>;
export type GeneralSitesLazyQueryHookResult = ReturnType<typeof useGeneralSitesLazyQuery>;
export type GeneralSitesQueryResult = Apollo.QueryResult<GeneralSitesQuery, GeneralSitesQueryVariables>;
export const GeneralLandingPagesDocument = gql`
    query generalLandingPages($extractid: Int!, $filter: ExtractFilter, $clusterid: Int, $site: String, $word: String, $befaft: Int) {
  extract(extractid: $extractid) {
    general {
      landingPages(
        filter: $filter
        clusterid: $clusterid
        site: $site
        word: $word
        befaft: $befaft
      )
    }
  }
}
    `;

/**
 * __useGeneralLandingPagesQuery__
 *
 * To run a query within a React component, call `useGeneralLandingPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralLandingPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralLandingPagesQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *      site: // value for 'site'
 *      word: // value for 'word'
 *      befaft: // value for 'befaft'
 *   },
 * });
 */
export function useGeneralLandingPagesQuery(baseOptions: Apollo.QueryHookOptions<GeneralLandingPagesQuery, GeneralLandingPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneralLandingPagesQuery, GeneralLandingPagesQueryVariables>(GeneralLandingPagesDocument, options);
      }
export function useGeneralLandingPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneralLandingPagesQuery, GeneralLandingPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneralLandingPagesQuery, GeneralLandingPagesQueryVariables>(GeneralLandingPagesDocument, options);
        }
export type GeneralLandingPagesQueryHookResult = ReturnType<typeof useGeneralLandingPagesQuery>;
export type GeneralLandingPagesLazyQueryHookResult = ReturnType<typeof useGeneralLandingPagesLazyQuery>;
export type GeneralLandingPagesQueryResult = Apollo.QueryResult<GeneralLandingPagesQuery, GeneralLandingPagesQueryVariables>;
export const BeforeAfterDocument = gql`
    query beforeAfter($extractid: Int!, $filter: ExtractFilter, $clusterid: Int, $beforeAfter: Int!, $limit: Int) {
  extract(extractid: $extractid) {
    beforeAfter(
      filter: $filter
      clusterid: $clusterid
      beforeAfter: $beforeAfter
      limit: $limit
    )
  }
}
    `;

/**
 * __useBeforeAfterQuery__
 *
 * To run a query within a React component, call `useBeforeAfterQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeforeAfterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeforeAfterQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *      beforeAfter: // value for 'beforeAfter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBeforeAfterQuery(baseOptions: Apollo.QueryHookOptions<BeforeAfterQuery, BeforeAfterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BeforeAfterQuery, BeforeAfterQueryVariables>(BeforeAfterDocument, options);
      }
export function useBeforeAfterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BeforeAfterQuery, BeforeAfterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BeforeAfterQuery, BeforeAfterQueryVariables>(BeforeAfterDocument, options);
        }
export type BeforeAfterQueryHookResult = ReturnType<typeof useBeforeAfterQuery>;
export type BeforeAfterLazyQueryHookResult = ReturnType<typeof useBeforeAfterLazyQuery>;
export type BeforeAfterQueryResult = Apollo.QueryResult<BeforeAfterQuery, BeforeAfterQueryVariables>;
export const BeforeAfterWordDocument = gql`
    query beforeAfterWord($extractid: Int!, $filter: ExtractFilter, $clusterid: Int, $beforeAfter: Int!, $limit: Int) {
  extract(extractid: $extractid) {
    beforeAfterWord(
      filter: $filter
      clusterid: $clusterid
      beforeAfter: $beforeAfter
      limit: $limit
    )
  }
}
    `;

/**
 * __useBeforeAfterWordQuery__
 *
 * To run a query within a React component, call `useBeforeAfterWordQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeforeAfterWordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeforeAfterWordQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *      beforeAfter: // value for 'beforeAfter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBeforeAfterWordQuery(baseOptions: Apollo.QueryHookOptions<BeforeAfterWordQuery, BeforeAfterWordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BeforeAfterWordQuery, BeforeAfterWordQueryVariables>(BeforeAfterWordDocument, options);
      }
export function useBeforeAfterWordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BeforeAfterWordQuery, BeforeAfterWordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BeforeAfterWordQuery, BeforeAfterWordQueryVariables>(BeforeAfterWordDocument, options);
        }
export type BeforeAfterWordQueryHookResult = ReturnType<typeof useBeforeAfterWordQuery>;
export type BeforeAfterWordLazyQueryHookResult = ReturnType<typeof useBeforeAfterWordLazyQuery>;
export type BeforeAfterWordQueryResult = Apollo.QueryResult<BeforeAfterWordQuery, BeforeAfterWordQueryVariables>;
export const BeforeAfterAppDocument = gql`
    query beforeAfterApp($extractid: Int!, $filter: ExtractFilter, $clusterid: Int, $beforeAfter: Int!, $limit: Int) {
  extract(extractid: $extractid) {
    beforeAfterApp(
      filter: $filter
      clusterid: $clusterid
      beforeAfter: $beforeAfter
      limit: $limit
    )
  }
}
    `;

/**
 * __useBeforeAfterAppQuery__
 *
 * To run a query within a React component, call `useBeforeAfterAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeforeAfterAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeforeAfterAppQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *      beforeAfter: // value for 'beforeAfter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBeforeAfterAppQuery(baseOptions: Apollo.QueryHookOptions<BeforeAfterAppQuery, BeforeAfterAppQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BeforeAfterAppQuery, BeforeAfterAppQueryVariables>(BeforeAfterAppDocument, options);
      }
export function useBeforeAfterAppLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BeforeAfterAppQuery, BeforeAfterAppQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BeforeAfterAppQuery, BeforeAfterAppQueryVariables>(BeforeAfterAppDocument, options);
        }
export type BeforeAfterAppQueryHookResult = ReturnType<typeof useBeforeAfterAppQuery>;
export type BeforeAfterAppLazyQueryHookResult = ReturnType<typeof useBeforeAfterAppLazyQuery>;
export type BeforeAfterAppQueryResult = Apollo.QueryResult<BeforeAfterAppQuery, BeforeAfterAppQueryVariables>;
export const BeforeAfterSankeyDocument = gql`
    query beforeAfterSankey($extractid: Int!, $filter: ExtractFilter, $clusterid: Int, $beforeAfter: Int!, $site: String, $word: String, $limit: Int) {
  extract(extractid: $extractid) {
    beforeAfterSankey(
      filter: $filter
      clusterid: $clusterid
      beforeAfter: $beforeAfter
      site: $site
      word: $word
      limit: $limit
    )
  }
}
    `;

/**
 * __useBeforeAfterSankeyQuery__
 *
 * To run a query within a React component, call `useBeforeAfterSankeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeforeAfterSankeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeforeAfterSankeyQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *      beforeAfter: // value for 'beforeAfter'
 *      site: // value for 'site'
 *      word: // value for 'word'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBeforeAfterSankeyQuery(baseOptions: Apollo.QueryHookOptions<BeforeAfterSankeyQuery, BeforeAfterSankeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BeforeAfterSankeyQuery, BeforeAfterSankeyQueryVariables>(BeforeAfterSankeyDocument, options);
      }
export function useBeforeAfterSankeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BeforeAfterSankeyQuery, BeforeAfterSankeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BeforeAfterSankeyQuery, BeforeAfterSankeyQueryVariables>(BeforeAfterSankeyDocument, options);
        }
export type BeforeAfterSankeyQueryHookResult = ReturnType<typeof useBeforeAfterSankeyQuery>;
export type BeforeAfterSankeyLazyQueryHookResult = ReturnType<typeof useBeforeAfterSankeyLazyQuery>;
export type BeforeAfterSankeyQueryResult = Apollo.QueryResult<BeforeAfterSankeyQuery, BeforeAfterSankeyQueryVariables>;
export const CanExtractDocument = gql`
    mutation canExtract {
  canExtract
}
    `;
export type CanExtractMutationFn = Apollo.MutationFunction<CanExtractMutation, CanExtractMutationVariables>;

/**
 * __useCanExtractMutation__
 *
 * To run a mutation, you first call `useCanExtractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCanExtractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [canExtractMutation, { data, loading, error }] = useCanExtractMutation({
 *   variables: {
 *   },
 * });
 */
export function useCanExtractMutation(baseOptions?: Apollo.MutationHookOptions<CanExtractMutation, CanExtractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CanExtractMutation, CanExtractMutationVariables>(CanExtractDocument, options);
      }
export type CanExtractMutationHookResult = ReturnType<typeof useCanExtractMutation>;
export type CanExtractMutationResult = Apollo.MutationResult<CanExtractMutation>;
export type CanExtractMutationOptions = Apollo.BaseMutationOptions<CanExtractMutation, CanExtractMutationVariables>;
export const HitCountDocument = gql`
    query hitCount($extractid: Int!, $filter: ExtractFilter, $clusterid: Int) {
  extract(extractid: $extractid) {
    hitCount(filter: $filter, clusterid: $clusterid)
  }
}
    `;

/**
 * __useHitCountQuery__
 *
 * To run a query within a React component, call `useHitCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useHitCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHitCountQuery({
 *   variables: {
 *      extractid: // value for 'extractid'
 *      filter: // value for 'filter'
 *      clusterid: // value for 'clusterid'
 *   },
 * });
 */
export function useHitCountQuery(baseOptions: Apollo.QueryHookOptions<HitCountQuery, HitCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HitCountQuery, HitCountQueryVariables>(HitCountDocument, options);
      }
export function useHitCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HitCountQuery, HitCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HitCountQuery, HitCountQueryVariables>(HitCountDocument, options);
        }
export type HitCountQueryHookResult = ReturnType<typeof useHitCountQuery>;
export type HitCountLazyQueryHookResult = ReturnType<typeof useHitCountLazyQuery>;
export type HitCountQueryResult = Apollo.QueryResult<HitCountQuery, HitCountQueryVariables>;